//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import http from '../utils/http';import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ApiBase {
  http: any;
  protected constructor() {
    this.http = http;
  }
}

export class AcademyApi extends ApiBase {
    instance: AxiosInstance;
    baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : this.http;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: AcademyInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Academy/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCourse(body: CourseCreateDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Academy/CreateCourse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCourse(_response);
        });
    }

    protected processCreateCourse(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAcademiesWithGrades(  cancelToken?: CancelToken | undefined): Promise<GetAcademyOutputDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Academy/GetAcademiesWithGrades";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAcademiesWithGrades(_response);
        });
    }

    protected processGetAcademiesWithGrades(response: AxiosResponse): Promise<GetAcademyOutputDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAcademyOutputDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<GetAcademyOutputDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAcademyOutputDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAcademyById(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<AcademyInputDto> {
        let url_ = this.baseUrl + "/api/services/app/Academy/GetAcademyById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAcademyById(_response);
        });
    }

    protected processGetAcademyById(response: AxiosResponse): Promise<AcademyInputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AcademyInputDto.fromJS(resultData200);
            return Promise.resolve<AcademyInputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcademyInputDto>(null as any);
    }

    /**
     * @return Success
     */
    getCoursesByGrade(grade: string, academyId: string , cancelToken?: CancelToken | undefined): Promise<GuidNameValueDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Academy/GetCoursesByGrade?";
        if (grade === undefined || grade === null)
            throw new Error("The parameter 'grade' must be defined and cannot be null.");
        else
            url_ += "Grade=" + encodeURIComponent("" + grade) + "&";
        if (academyId === undefined || academyId === null)
            throw new Error("The parameter 'academyId' must be defined and cannot be null.");
        else
            url_ += "AcademyId=" + encodeURIComponent("" + academyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCoursesByGrade(_response);
        });
    }

    protected processGetCoursesByGrade(response: AxiosResponse): Promise<GuidNameValueDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GuidNameValueDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<GuidNameValueDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GuidNameValueDtoListResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getTopicsById(courseId: string, grade: string, academyId: string , cancelToken?: CancelToken | undefined): Promise<PRTopicOutputDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Academy/GetTopicsById?";
        if (courseId === undefined || courseId === null)
            throw new Error("The parameter 'courseId' must be defined and cannot be null.");
        else
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        if (grade === undefined || grade === null)
            throw new Error("The parameter 'grade' must be defined and cannot be null.");
        else
            url_ += "Grade=" + encodeURIComponent("" + grade) + "&";
        if (academyId === undefined || academyId === null)
            throw new Error("The parameter 'academyId' must be defined and cannot be null.");
        else
            url_ += "AcademyId=" + encodeURIComponent("" + academyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTopicsById(_response);
        });
    }

    protected processGetTopicsById(response: AxiosResponse): Promise<PRTopicOutputDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PRTopicOutputDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<PRTopicOutputDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PRTopicOutputDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEvalReportByCID(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<AcademyReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Academy/GetEvalReportByCID?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEvalReportByCID(_response);
        });
    }

    protected processGetEvalReportByCID(response: AxiosResponse): Promise<AcademyReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AcademyReportDto.fromJS(resultData200);
            return Promise.resolve<AcademyReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcademyReportDto>(null as any);
    }

    /**
     * @param courseTopicId (optional) 
     * @return Success
     */
    getEvalReportStudentByCID(courseTopicId: number | undefined , cancelToken?: CancelToken | undefined): Promise<StudentReportOutputDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Academy/GetEvalReportStudentByCID?";
        if (courseTopicId === null)
            throw new Error("The parameter 'courseTopicId' cannot be null.");
        else if (courseTopicId !== undefined)
            url_ += "courseTopicId=" + encodeURIComponent("" + courseTopicId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEvalReportStudentByCID(_response);
        });
    }

    protected processGetEvalReportStudentByCID(response: AxiosResponse): Promise<StudentReportOutputDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudentReportOutputDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<StudentReportOutputDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentReportOutputDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCourseDetail(body: CourseDetailDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Academy/UpdateCourseDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCourseDetail(_response);
        });
    }

    protected processUpdateCourseDetail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAcademiesForSelect(  cancelToken?: CancelToken | undefined): Promise<GuidNameValueDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Academy/GetAcademiesForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAcademiesForSelect(_response);
        });
    }

    protected processGetAcademiesForSelect(response: AxiosResponse): Promise<GuidNameValueDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GuidNameValueDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<GuidNameValueDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GuidNameValueDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getClassesByAId(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<Int32AcademyClassDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Academy/GetClassesByAId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClassesByAId(_response);
        });
    }

    protected processGetClassesByAId(response: AxiosResponse): Promise<Int32AcademyClassDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Int32AcademyClassDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<Int32AcademyClassDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32AcademyClassDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getClassesByClassId(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<Int32NameValueListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Academy/GetClassesByClassId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClassesByClassId(_response);
        });
    }

    protected processGetClassesByClassId(response: AxiosResponse): Promise<Int32NameValueListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Int32NameValueListResultDto.fromJS(resultData200);
            return Promise.resolve<Int32NameValueListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32NameValueListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCoursesByClassId(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<GuidAcademyClassCourseDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Academy/GetCoursesByClassId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCoursesByClassId(_response);
        });
    }

    protected processGetCoursesByClassId(response: AxiosResponse): Promise<GuidAcademyClassCourseDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GuidAcademyClassCourseDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<GuidAcademyClassCourseDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GuidAcademyClassCourseDtoListResultDto>(null as any);
    }

    /**
     * @param classId (optional) 
     * @param courseId (optional) 
     * @return Success
     */
    getChaptersByClassIdAndCourseId(classId: number | undefined, courseId: string | undefined , cancelToken?: CancelToken | undefined): Promise<Int32ReadinessDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Academy/GetChaptersByClassIdAndCourseId?";
        if (classId === null)
            throw new Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "ClassId=" + encodeURIComponent("" + classId) + "&";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChaptersByClassIdAndCourseId(_response);
        });
    }

    protected processGetChaptersByClassIdAndCourseId(response: AxiosResponse): Promise<Int32ReadinessDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Int32ReadinessDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<Int32ReadinessDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32ReadinessDtoListResultDto>(null as any);
    }
}

export class ArticleApi extends ApiBase {
    instance: AxiosInstance;
    baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : this.http;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param filter (optional) 
     * @param topicId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getArticles(filter: string | undefined, topicId: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<ArticleListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetArticles?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (topicId === null)
            throw new Error("The parameter 'topicId' cannot be null.");
        else if (topicId !== undefined)
            url_ += "TopicId=" + encodeURIComponent("" + topicId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticles(_response);
        });
    }

    protected processGetArticles(response: AxiosResponse): Promise<ArticleListDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleListDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ArticleListDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleListDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createArticle(body: CreateArticleInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Article/CreateArticle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateArticle(_response);
        });
    }

    protected processCreateArticle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param topicId (optional) 
     * @param id (optional) 
     * @return Success
     */
    getArticleForEdit(topicId: number | undefined, id: number | undefined , cancelToken?: CancelToken | undefined): Promise<ArticleEditOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetArticleForEdit?";
        if (topicId === null)
            throw new Error("The parameter 'topicId' cannot be null.");
        else if (topicId !== undefined)
            url_ += "TopicId=" + encodeURIComponent("" + topicId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticleForEdit(_response);
        });
    }

    protected processGetArticleForEdit(response: AxiosResponse): Promise<ArticleEditOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleEditOutputDto.fromJS(resultData200);
            return Promise.resolve<ArticleEditOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleEditOutputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateArticle(body: UpdateArticleInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Article/UpdateArticle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateArticle(_response);
        });
    }

    protected processUpdateArticle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CetApi extends ApiBase {
    instance: AxiosInstance;
    baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : this.http;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getMyGoals(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Cet/GetMyGoals";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyGoals(_response);
        });
    }

    protected processGetMyGoals(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMyGoals(body: UpdateMyGoalsInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Cet/UpdateMyGoals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMyGoals(_response);
        });
    }

    protected processUpdateMyGoals(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ConfigurationApi extends ApiBase {
    instance: AxiosInstance;
    baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : this.http;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUiTheme(_response);
        });
    }

    protected processChangeUiTheme(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EditionApi extends ApiBase {
    instance: AxiosInstance;
    baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : this.http;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateEditionDto | undefined , cancelToken?: CancelToken | undefined): Promise<EditionDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<EditionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditionDto.fromJS(resultData200);
            return Promise.resolve<EditionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEditionForEdit(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<GetEditionForEditOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEditionForEdit(_response);
        });
    }

    protected processGetEditionForEdit(response: AxiosResponse): Promise<GetEditionForEditOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEditionForEditOutputDto.fromJS(resultData200);
            return Promise.resolve<GetEditionForEditOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEditionForEditOutputDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllFeatures(  cancelToken?: CancelToken | undefined): Promise<FeatureDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetAllFeatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllFeatures(_response);
        });
    }

    protected processGetAllFeatures(response: AxiosResponse): Promise<FeatureDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeatureDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<FeatureDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeatureDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<EditionDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<EditionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditionDto.fromJS(resultData200);
            return Promise.resolve<EditionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditionDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<EditionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<EditionDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditionDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<EditionDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditionDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: EditionDto | undefined , cancelToken?: CancelToken | undefined): Promise<EditionDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<EditionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditionDto.fromJS(resultData200);
            return Promise.resolve<EditionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LearnerApi extends ApiBase {
    instance: AxiosInstance;
    baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : this.http;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getCourses(  cancelToken?: CancelToken | undefined): Promise<CourseListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Learner/GetCourses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourses(_response);
        });
    }

    protected processGetCourses(response: AxiosResponse): Promise<CourseListDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourseListDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<CourseListDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseListDtoListResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getPendingEvals(  cancelToken?: CancelToken | undefined): Promise<LearnerTopicEvalDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Learner/GetPendingEvals";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPendingEvals(_response);
        });
    }

    protected processGetPendingEvals(response: AxiosResponse): Promise<LearnerTopicEvalDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LearnerTopicEvalDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<LearnerTopicEvalDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LearnerTopicEvalDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCourseById(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<StuCourseDto> {
        let url_ = this.baseUrl + "/api/services/app/Learner/GetCourseById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseById(_response);
        });
    }

    protected processGetCourseById(response: AxiosResponse): Promise<StuCourseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StuCourseDto.fromJS(resultData200);
            return Promise.resolve<StuCourseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StuCourseDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCourseTopicDetailById(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<StuCourseTopicDto> {
        let url_ = this.baseUrl + "/api/services/app/Learner/GetCourseTopicDetailById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseTopicDetailById(_response);
        });
    }

    protected processGetCourseTopicDetailById(response: AxiosResponse): Promise<StuCourseTopicDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StuCourseTopicDto.fromJS(resultData200);
            return Promise.resolve<StuCourseTopicDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StuCourseTopicDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCourseDetail(body: StuCourseDetailDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Learner/UpdateCourseDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCourseDetail(_response);
        });
    }

    protected processUpdateCourseDetail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param courseID (optional) 
     * @param topicId (optional) 
     * @param fMapId (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getFMaps(courseID: string | undefined, topicId: number | undefined, fMapId: string | undefined, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<FMapInit> {
        let url_ = this.baseUrl + "/api/services/app/Learner/GetFMaps?";
        if (courseID === null)
            throw new Error("The parameter 'courseID' cannot be null.");
        else if (courseID !== undefined)
            url_ += "CourseID=" + encodeURIComponent("" + courseID) + "&";
        if (topicId === null)
            throw new Error("The parameter 'topicId' cannot be null.");
        else if (topicId !== undefined)
            url_ += "TopicId=" + encodeURIComponent("" + topicId) + "&";
        if (fMapId === null)
            throw new Error("The parameter 'fMapId' cannot be null.");
        else if (fMapId !== undefined)
            url_ += "FMapId=" + encodeURIComponent("" + fMapId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFMaps(_response);
        });
    }

    protected processGetFMaps(response: AxiosResponse): Promise<FMapInit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FMapInit.fromJS(resultData200);
            return Promise.resolve<FMapInit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FMapInit>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchFMaps(body: GetFMapsInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FMapInit> {
        let url_ = this.baseUrl + "/api/services/app/Learner/SearchFMaps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFMaps(_response);
        });
    }

    protected processSearchFMaps(response: AxiosResponse): Promise<FMapInit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FMapInit.fromJS(resultData200);
            return Promise.resolve<FMapInit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FMapInit>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFMapsbycourseTopic(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<FMapInit> {
        let url_ = this.baseUrl + "/api/services/app/Learner/GetFMapsbycourseTopic?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFMapsbycourseTopic(_response);
        });
    }

    protected processGetFMapsbycourseTopic(response: AxiosResponse): Promise<FMapInit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FMapInit.fromJS(resultData200);
            return Promise.resolve<FMapInit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FMapInit>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFMapById(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<FMapDto> {
        let url_ = this.baseUrl + "/api/services/app/Learner/GetFMapById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFMapById(_response);
        });
    }

    protected processGetFMapById(response: AxiosResponse): Promise<FMapDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FMapDto.fromJS(resultData200);
            return Promise.resolve<FMapDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FMapDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNewFMapByCourseTopicId(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<FMapDto> {
        let url_ = this.baseUrl + "/api/services/app/Learner/GetNewFMapByCourseTopicId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewFMapByCourseTopicId(_response);
        });
    }

    protected processGetNewFMapByCourseTopicId(response: AxiosResponse): Promise<FMapDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FMapDto.fromJS(resultData200);
            return Promise.resolve<FMapDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FMapDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateFMap(body: FMapDto | undefined , cancelToken?: CancelToken | undefined): Promise<FMapDto> {
        let url_ = this.baseUrl + "/api/services/app/Learner/CreateUpdateFMap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUpdateFMap(_response);
        });
    }

    protected processCreateUpdateFMap(response: AxiosResponse): Promise<FMapDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FMapDto.fromJS(resultData200);
            return Promise.resolve<FMapDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FMapDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFMapItem(body: FMapItemDto | undefined , cancelToken?: CancelToken | undefined): Promise<FMapItemDto> {
        let url_ = this.baseUrl + "/api/services/app/Learner/CreateFMapItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFMapItem(_response);
        });
    }

    protected processCreateFMapItem(response: AxiosResponse): Promise<FMapItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FMapItemDto.fromJS(resultData200);
            return Promise.resolve<FMapItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FMapItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateResource(body: TopicResourceDto | undefined , cancelToken?: CancelToken | undefined): Promise<TopicResourceDto> {
        let url_ = this.baseUrl + "/api/services/app/Learner/UpdateResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateResource(_response);
        });
    }

    protected processUpdateResource(response: AxiosResponse): Promise<TopicResourceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TopicResourceDto.fromJS(resultData200);
            return Promise.resolve<TopicResourceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopicResourceDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteFMapItem(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<FMapDto> {
        let url_ = this.baseUrl + "/api/services/app/Learner/DeleteFMapItem?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFMapItem(_response);
        });
    }

    protected processDeleteFMapItem(response: AxiosResponse): Promise<FMapDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FMapDto.fromJS(resultData200);
            return Promise.resolve<FMapDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FMapDto>(null as any);
    }

    /**
     * @param cdid (optional) 
     * @param qid (optional) 
     * @return Success
     */
    getAskFriends(cdid: number | undefined, qid: number | undefined , cancelToken?: CancelToken | undefined): Promise<FriendsDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Learner/GetAskFriends?";
        if (cdid === null)
            throw new Error("The parameter 'cdid' cannot be null.");
        else if (cdid !== undefined)
            url_ += "cdid=" + encodeURIComponent("" + cdid) + "&";
        if (qid === null)
            throw new Error("The parameter 'qid' cannot be null.");
        else if (qid !== undefined)
            url_ += "qid=" + encodeURIComponent("" + qid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAskFriends(_response);
        });
    }

    protected processGetAskFriends(response: AxiosResponse): Promise<FriendsDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FriendsDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<FriendsDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FriendsDtoListResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getMyDoubts(  cancelToken?: CancelToken | undefined): Promise<DoubtDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Learner/GetMyDoubts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyDoubts(_response);
        });
    }

    protected processGetMyDoubts(response: AxiosResponse): Promise<DoubtDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DoubtDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<DoubtDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DoubtDtoListResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getMyReviseList(  cancelToken?: CancelToken | undefined): Promise<DoubtDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Learner/GetMyReviseList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyReviseList(_response);
        });
    }

    protected processGetMyReviseList(response: AxiosResponse): Promise<DoubtDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DoubtDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<DoubtDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DoubtDtoListResultDto>(null as any);
    }

    /**
     * @param qId (optional) 
     * @return Success
     */
    getQuestionDetail(qId: number | undefined , cancelToken?: CancelToken | undefined): Promise<DRQuestionDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Learner/GetQuestionDetail?";
        if (qId === null)
            throw new Error("The parameter 'qId' cannot be null.");
        else if (qId !== undefined)
            url_ += "qId=" + encodeURIComponent("" + qId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionDetail(_response);
        });
    }

    protected processGetQuestionDetail(response: AxiosResponse): Promise<DRQuestionDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DRQuestionDetailDto.fromJS(resultData200);
            return Promise.resolve<DRQuestionDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DRQuestionDetailDto>(null as any);
    }
}

export class LearnerEvalApi extends ApiBase {
    instance: AxiosInstance;
    baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : this.http;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInitialEval(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<QEvalDto> {
        let url_ = this.baseUrl + "/api/services/app/LearnerEval/GetInitialEval?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInitialEval(_response);
        });
    }

    protected processGetInitialEval(response: AxiosResponse): Promise<QEvalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QEvalDto.fromJS(resultData200);
            return Promise.resolve<QEvalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QEvalDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    evalComplete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LearnerEval/EvalComplete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEvalComplete(_response);
        });
    }

    protected processEvalComplete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateQAns(body: QEvalInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LearnerEval/UpdateQAns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQAns(_response);
        });
    }

    protected processUpdateQAns(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBasicEvalReview(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<QEvalReviewDto> {
        let url_ = this.baseUrl + "/api/services/app/LearnerEval/GetBasicEvalReview?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicEvalReview(_response);
        });
    }

    protected processGetBasicEvalReview(response: AxiosResponse): Promise<QEvalReviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QEvalReviewDto.fromJS(resultData200);
            return Promise.resolve<QEvalReviewDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QEvalReviewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBasicEvalReport(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<QEvalReportDto> {
        let url_ = this.baseUrl + "/api/services/app/LearnerEval/GetBasicEvalReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicEvalReport(_response);
        });
    }

    protected processGetBasicEvalReport(response: AxiosResponse): Promise<QEvalReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QEvalReportDto.fromJS(resultData200);
            return Promise.resolve<QEvalReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QEvalReportDto>(null as any);
    }

    /**
     * @param qid (optional) 
     * @return Success
     */
    getSolnForQid(qid: number | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/LearnerEval/GetSolnForQid?";
        if (qid === null)
            throw new Error("The parameter 'qid' cannot be null.");
        else if (qid !== undefined)
            url_ += "qid=" + encodeURIComponent("" + qid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSolnForQid(_response);
        });
    }

    protected processGetSolnForQid(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateQBookmark(body: UpdateQActionInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LearnerEval/UpdateQBookmark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQBookmark(_response);
        });
    }

    protected processUpdateQBookmark(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateQSillyMistake(body: UpdateQActionInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LearnerEval/UpdateQSillyMistake";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQSillyMistake(_response);
        });
    }

    protected processUpdateQSillyMistake(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateQDoubt(body: UpdateQActionInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LearnerEval/UpdateQDoubt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQDoubt(_response);
        });
    }

    protected processUpdateQDoubt(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MediaApi extends ApiBase {
    instance: AxiosInstance;
    baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : this.http;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    uploadImage(  cancelToken?: CancelToken | undefined): Promise<UploadImageOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Media/UploadImage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadImage(_response);
        });
    }

    protected processUploadImage(response: AxiosResponse): Promise<UploadImageOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadImageOutputDto.fromJS(resultData200);
            return Promise.resolve<UploadImageOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadImageOutputDto>(null as any);
    }

    /**
     * @param filename (optional) 
     * @return Success
     */
    image(filename: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Media/Image?";
        if (filename === null)
            throw new Error("The parameter 'filename' cannot be null.");
        else if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImage(_response);
        });
    }

    protected processImage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param webLink (optional) 
     * @param topicId (optional) 
     * @return Success
     */
    getImgLinks(webLink: string | undefined, topicId: number | undefined , cancelToken?: CancelToken | undefined): Promise<StringListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Media/GetImgLinks?";
        if (webLink === null)
            throw new Error("The parameter 'webLink' cannot be null.");
        else if (webLink !== undefined)
            url_ += "WebLink=" + encodeURIComponent("" + webLink) + "&";
        if (topicId === null)
            throw new Error("The parameter 'topicId' cannot be null.");
        else if (topicId !== undefined)
            url_ += "TopicId=" + encodeURIComponent("" + topicId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImgLinks(_response);
        });
    }

    protected processGetImgLinks(response: AxiosResponse): Promise<StringListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StringListResultDto.fromJS(resultData200);
            return Promise.resolve<StringListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StringListResultDto>(null as any);
    }
}

export class QItemApi extends ApiBase {
    instance: AxiosInstance;
    baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : this.http;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param filter (optional) 
     * @param topicId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getQItems(filter: string | undefined, topicId: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<QItemResultDto> {
        let url_ = this.baseUrl + "/api/services/app/QItem/GetQItems?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (topicId === null)
            throw new Error("The parameter 'topicId' cannot be null.");
        else if (topicId !== undefined)
            url_ += "TopicId=" + encodeURIComponent("" + topicId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQItems(_response);
        });
    }

    protected processGetQItems(response: AxiosResponse): Promise<QItemResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QItemResultDto.fromJS(resultData200);
            return Promise.resolve<QItemResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QItemResultDto>(null as any);
    }

    /**
     * @param qtextKeyword (optional) 
     * @param sourceKeyword (optional) 
     * @return Success
     */
    getQItemSearch(qtextKeyword: string | undefined, sourceKeyword: string | undefined , cancelToken?: CancelToken | undefined): Promise<QItemResultDto> {
        let url_ = this.baseUrl + "/api/services/app/QItem/GetQItemSearch?";
        if (qtextKeyword === null)
            throw new Error("The parameter 'qtextKeyword' cannot be null.");
        else if (qtextKeyword !== undefined)
            url_ += "QtextKeyword=" + encodeURIComponent("" + qtextKeyword) + "&";
        if (sourceKeyword === null)
            throw new Error("The parameter 'sourceKeyword' cannot be null.");
        else if (sourceKeyword !== undefined)
            url_ += "SourceKeyword=" + encodeURIComponent("" + sourceKeyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQItemSearch(_response);
        });
    }

    protected processGetQItemSearch(response: AxiosResponse): Promise<QItemResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QItemResultDto.fromJS(resultData200);
            return Promise.resolve<QItemResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QItemResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param topicId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getQItemsById(filter: string | undefined, topicId: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<QItemListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/QItem/GetQItemsById?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (topicId === null)
            throw new Error("The parameter 'topicId' cannot be null.");
        else if (topicId !== undefined)
            url_ += "TopicId=" + encodeURIComponent("" + topicId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQItemsById(_response);
        });
    }

    protected processGetQItemsById(response: AxiosResponse): Promise<QItemListDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QItemListDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<QItemListDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QItemListDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param topicId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getQItemsByTagId(filter: string | undefined, topicId: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<QItemListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/QItem/GetQItemsByTagId?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (topicId === null)
            throw new Error("The parameter 'topicId' cannot be null.");
        else if (topicId !== undefined)
            url_ += "TopicId=" + encodeURIComponent("" + topicId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQItemsByTagId(_response);
        });
    }

    protected processGetQItemsByTagId(response: AxiosResponse): Promise<QItemListDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QItemListDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<QItemListDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QItemListDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param topicId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getQCount(filter: string | undefined, topicId: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<QCountListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/QItem/GetQCount?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (topicId === null)
            throw new Error("The parameter 'topicId' cannot be null.");
        else if (topicId !== undefined)
            url_ += "TopicId=" + encodeURIComponent("" + topicId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQCount(_response);
        });
    }

    protected processGetQCount(response: AxiosResponse): Promise<QCountListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QCountListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QCountListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QCountListDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createQItem(body: CreateQItemInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<EntityDto> {
        let url_ = this.baseUrl + "/api/services/app/QItem/CreateQItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateQItem(_response);
        });
    }

    protected processCreateQItem(response: AxiosResponse): Promise<EntityDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityDto.fromJS(resultData200);
            return Promise.resolve<EntityDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityDto>(null as any);
    }

    /**
     * @param topicId (optional) 
     * @param id (optional) 
     * @return Success
     */
    getQItemForEdit(topicId: number | undefined, id: number | undefined , cancelToken?: CancelToken | undefined): Promise<QItemEditOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/QItem/GetQItemForEdit?";
        if (topicId === null)
            throw new Error("The parameter 'topicId' cannot be null.");
        else if (topicId !== undefined)
            url_ += "TopicId=" + encodeURIComponent("" + topicId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQItemForEdit(_response);
        });
    }

    protected processGetQItemForEdit(response: AxiosResponse): Promise<QItemEditOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QItemEditOutputDto.fromJS(resultData200);
            return Promise.resolve<QItemEditOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QItemEditOutputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateQItem(body: UpdateQItemInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/QItem/UpdateQItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQItem(_response);
        });
    }

    protected processUpdateQItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateQItemVerification(body: UpdateQItemVerificationInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/QItem/UpdateQItemVerification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQItemVerification(_response);
        });
    }

    protected processUpdateQItemVerification(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param topicId (optional) 
     * @param id (optional) 
     * @return Success
     */
    getAllTopicTags(topicId: number | undefined, id: number | undefined , cancelToken?: CancelToken | undefined): Promise<TopicTagListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/QItem/GetAllTopicTags?";
        if (topicId === null)
            throw new Error("The parameter 'topicId' cannot be null.");
        else if (topicId !== undefined)
            url_ += "TopicId=" + encodeURIComponent("" + topicId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTopicTags(_response);
        });
    }

    protected processGetAllTopicTags(response: AxiosResponse): Promise<TopicTagListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopicTagListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TopicTagListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopicTagListDto[]>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getTagsByName(input: string | undefined , cancelToken?: CancelToken | undefined): Promise<TopicTagListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/QItem/GetTagsByName?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTagsByName(_response);
        });
    }

    protected processGetTagsByName(response: AxiosResponse): Promise<TopicTagListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopicTagListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TopicTagListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopicTagListDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkQitemForDuplicate(body: CheckQitemForDuplicateInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/QItem/CheckQitemForDuplicate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckQitemForDuplicate(_response);
        });
    }

    protected processCheckQitemForDuplicate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RoleApi extends ApiBase {
    instance: AxiosInstance;
    baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : this.http;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined , cancelToken?: CancelToken | undefined): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return Promise.resolve<RoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | undefined , cancelToken?: CancelToken | undefined): Promise<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<RoleListDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<RoleListDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleListDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined , cancelToken?: CancelToken | undefined): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return Promise.resolve<RoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(  cancelToken?: CancelToken | undefined): Promise<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPermissions(_response);
        });
    }

    protected processGetAllPermissions(response: AxiosResponse): Promise<PermissionDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<PermissionDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PermissionDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoleForEdit(_response);
        });
    }

    protected processGetRoleForEdit(response: AxiosResponse): Promise<GetRoleForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetRoleForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return Promise.resolve<RoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<RoleDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<RoleDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDtoPagedResultDto>(null as any);
    }
}

export class SessionApi extends ApiBase {
    instance: AxiosInstance;
    baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : this.http;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(  cancelToken?: CancelToken | undefined): Promise<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentLoginInformations(_response);
        });
    }

    protected processGetCurrentLoginInformations(response: AxiosResponse): Promise<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return Promise.resolve<GetCurrentLoginInformationsOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCurrentLoginInformationsOutput>(null as any);
    }
}

export class TenantApi extends ApiBase {
    instance: AxiosInstance;
    baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : this.http;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined , cancelToken?: CancelToken | undefined): Promise<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<TenantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDto.fromJS(resultData200);
            return Promise.resolve<TenantDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<TenantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDto.fromJS(resultData200);
            return Promise.resolve<TenantDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<TenantDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<TenantDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined , cancelToken?: CancelToken | undefined): Promise<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<TenantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDto.fromJS(resultData200);
            return Promise.resolve<TenantDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDto>(null as any);
    }
}

export class TokenAuthApi extends ApiBase {
    instance: AxiosInstance;
    baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : this.http;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined , cancelToken?: CancelToken | undefined): Promise<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: AxiosResponse): Promise<AuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<AuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInputModel | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verify(body: VerifyInputModel | undefined , cancelToken?: CancelToken | undefined): Promise<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: AxiosResponse): Promise<AuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<AuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResultModel>(null as any);
    }

    /**
     * @param userName (optional) 
     * @return Success
     */
    resendCode(userName: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/ResendCode?";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendCode(_response);
        });
    }

    protected processResendCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TopicApi extends ApiBase {
    instance: AxiosInstance;
    baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : this.http;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getTopics(  cancelToken?: CancelToken | undefined): Promise<TopicDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Topic/GetTopics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTopics(_response);
        });
    }

    protected processGetTopics(response: AxiosResponse): Promise<TopicDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TopicDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<TopicDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopicDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTopicInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Topic/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateTopicInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Topic/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Topic/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getTopicTags(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<TopicTagListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Topic/GetTopicTags?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTopicTags(_response);
        });
    }

    protected processGetTopicTags(response: AxiosResponse): Promise<TopicTagListDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TopicTagListDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<TopicTagListDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopicTagListDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTopicTag(body: CreateTopicTagInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<TopicTagListDto> {
        let url_ = this.baseUrl + "/api/services/app/Topic/CreateTopicTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTopicTag(_response);
        });
    }

    protected processCreateTopicTag(response: AxiosResponse): Promise<TopicTagListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TopicTagListDto.fromJS(resultData200);
            return Promise.resolve<TopicTagListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopicTagListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTopicTag(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Topic/DeleteTopicTag?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTopicTag(_response);
        });
    }

    protected processDeleteTopicTag(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTopicTag(body: CreateTopicTagInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<TopicTagListDto> {
        let url_ = this.baseUrl + "/api/services/app/Topic/UpdateTopicTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTopicTag(_response);
        });
    }

    protected processUpdateTopicTag(response: AxiosResponse): Promise<TopicTagListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TopicTagListDto.fromJS(resultData200);
            return Promise.resolve<TopicTagListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopicTagListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTopicTagForEdit(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<CreateTopicTagInputDto> {
        let url_ = this.baseUrl + "/api/services/app/Topic/GetTopicTagForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTopicTagForEdit(_response);
        });
    }

    protected processGetTopicTagForEdit(response: AxiosResponse): Promise<CreateTopicTagInputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateTopicTagInputDto.fromJS(resultData200);
            return Promise.resolve<CreateTopicTagInputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateTopicTagInputDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllTopicTSRs(  cancelToken?: CancelToken | undefined): Promise<TSRListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Topic/GetAllTopicTSRs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTopicTSRs(_response);
        });
    }

    protected processGetAllTopicTSRs(response: AxiosResponse): Promise<TSRListDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TSRListDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<TSRListDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TSRListDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTopicTSR(body: CreateEditTSRInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<EntityDto> {
        let url_ = this.baseUrl + "/api/services/app/Topic/CreateTopicTSR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTopicTSR(_response);
        });
    }

    protected processCreateTopicTSR(response: AxiosResponse): Promise<EntityDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityDto.fromJS(resultData200);
            return Promise.resolve<EntityDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTopicTSRForEdit(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<CreateEditTSRInputDto> {
        let url_ = this.baseUrl + "/api/services/app/Topic/GetTopicTSRForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTopicTSRForEdit(_response);
        });
    }

    protected processGetTopicTSRForEdit(response: AxiosResponse): Promise<CreateEditTSRInputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateEditTSRInputDto.fromJS(resultData200);
            return Promise.resolve<CreateEditTSRInputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateEditTSRInputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTopicTSR(body: CreateEditTSRInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Topic/UpdateTopicTSR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTopicTSR(_response);
        });
    }

    protected processUpdateTopicTSR(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserApi extends ApiBase {
    instance: AxiosInstance;
    baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : this.http;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getUsers(keyword: string | undefined, isActive: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<UserDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<UserDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserForEdit(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<GetUserForEditOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserForEdit(_response);
        });
    }

    protected processGetUserForEdit(response: AxiosResponse): Promise<GetUserForEditOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserForEditOutputDto.fromJS(resultData200);
            return Promise.resolve<GetUserForEditOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserForEditOutputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activate(body: Int64EntityDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deActivate(body: Int64EntityDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeActivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeActivate(_response);
        });
    }

    protected processDeActivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeLanguage(_response);
        });
    }

    protected processChangeLanguage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class UtilApi extends ApiBase {
    instance: AxiosInstance;
    baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : this.http;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    analytics(body: CreateAnalyticInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Util/Analytics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnalytics(_response);
        });
    }

    protected processAnalytics(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.result;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data.result;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AReportByQDto implements IAReportByQDto {
    qId!: number;
    total!: number;
    skipped!: number;
    correct!: number;
    responseTime!: number;
    tags!: string | undefined;

    constructor(data?: IAReportByQDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qId = _data["qId"];
            this.total = _data["total"];
            this.skipped = _data["skipped"];
            this.correct = _data["correct"];
            this.responseTime = _data["responseTime"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): AReportByQDto {
        data = typeof data === 'object' ? data : {};
        let result = new AReportByQDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qId"] = this.qId;
        data["total"] = this.total;
        data["skipped"] = this.skipped;
        data["correct"] = this.correct;
        data["responseTime"] = this.responseTime;
        data["tags"] = this.tags;
        return data;
    }
}

export interface IAReportByQDto {
    qId: number;
    total: number;
    skipped: number;
    correct: number;
    responseTime: number;
    tags: string | undefined;
}

export class AReportByStudentDto implements IAReportByStudentDto {
    learnerUser!: string | undefined;
    learnerUserId!: number;
    totalQ!: number;
    responseTime!: number;
    skipped!: number;
    correct!: number;
    score!: number;

    constructor(data?: IAReportByStudentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.learnerUser = _data["learnerUser"];
            this.learnerUserId = _data["learnerUserId"];
            this.totalQ = _data["totalQ"];
            this.responseTime = _data["responseTime"];
            this.skipped = _data["skipped"];
            this.correct = _data["correct"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): AReportByStudentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AReportByStudentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["learnerUser"] = this.learnerUser;
        data["learnerUserId"] = this.learnerUserId;
        data["totalQ"] = this.totalQ;
        data["responseTime"] = this.responseTime;
        data["skipped"] = this.skipped;
        data["correct"] = this.correct;
        data["score"] = this.score;
        return data;
    }
}

export interface IAReportByStudentDto {
    learnerUser: string | undefined;
    learnerUserId: number;
    totalQ: number;
    responseTime: number;
    skipped: number;
    correct: number;
    score: number;
}

export class AcademyInputDto implements IAcademyInputDto {
    id!: string;
    name!: string;

    constructor(data?: IAcademyInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AcademyInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcademyInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAcademyInputDto {
    id: string;
    name: string;
}

export class AcademyReportDto implements IAcademyReportDto {
    title!: string | undefined;
    reportDataByTag!: QReportDataByTagDto;
    reportByStudent!: AReportByStudentDto[] | undefined;
    reportByQ!: AReportByQDto[] | undefined;
    reportByStudentHeatMap!: StudentHeatMapDto[] | undefined;
    studentReportPrByCTs!: StudentReportPrByCTDto[] | undefined;

    constructor(data?: IAcademyReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.reportDataByTag = _data["reportDataByTag"] ? QReportDataByTagDto.fromJS(_data["reportDataByTag"]) : <any>undefined;
            if (Array.isArray(_data["reportByStudent"])) {
                this.reportByStudent = [] as any;
                for (let item of _data["reportByStudent"])
                    this.reportByStudent!.push(AReportByStudentDto.fromJS(item));
            }
            if (Array.isArray(_data["reportByQ"])) {
                this.reportByQ = [] as any;
                for (let item of _data["reportByQ"])
                    this.reportByQ!.push(AReportByQDto.fromJS(item));
            }
            if (Array.isArray(_data["reportByStudentHeatMap"])) {
                this.reportByStudentHeatMap = [] as any;
                for (let item of _data["reportByStudentHeatMap"])
                    this.reportByStudentHeatMap!.push(StudentHeatMapDto.fromJS(item));
            }
            if (Array.isArray(_data["studentReportPrByCTs"])) {
                this.studentReportPrByCTs = [] as any;
                for (let item of _data["studentReportPrByCTs"])
                    this.studentReportPrByCTs!.push(StudentReportPrByCTDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AcademyReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcademyReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["reportDataByTag"] = this.reportDataByTag ? this.reportDataByTag.toJSON() : <any>undefined;
        if (Array.isArray(this.reportByStudent)) {
            data["reportByStudent"] = [];
            for (let item of this.reportByStudent)
                data["reportByStudent"].push(item.toJSON());
        }
        if (Array.isArray(this.reportByQ)) {
            data["reportByQ"] = [];
            for (let item of this.reportByQ)
                data["reportByQ"].push(item.toJSON());
        }
        if (Array.isArray(this.reportByStudentHeatMap)) {
            data["reportByStudentHeatMap"] = [];
            for (let item of this.reportByStudentHeatMap)
                data["reportByStudentHeatMap"].push(item.toJSON());
        }
        if (Array.isArray(this.studentReportPrByCTs)) {
            data["studentReportPrByCTs"] = [];
            for (let item of this.studentReportPrByCTs)
                data["studentReportPrByCTs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAcademyReportDto {
    title: string | undefined;
    reportDataByTag: QReportDataByTagDto;
    reportByStudent: AReportByStudentDto[] | undefined;
    reportByQ: AReportByQDto[] | undefined;
    reportByStudentHeatMap: StudentHeatMapDto[] | undefined;
    studentReportPrByCTs: StudentReportPrByCTDto[] | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: Date;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: Date;
    features: { [key: string]: boolean; } | undefined;
}

export class ArticleEditDto implements IArticleEditDto {
    id!: number | undefined;
    title!: string | undefined;
    content!: string | undefined;
    topicId!: number;

    constructor(data?: IArticleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.topicId = _data["topicId"];
        }
    }

    static fromJS(data: any): ArticleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["content"] = this.content;
        data["topicId"] = this.topicId;
        return data;
    }
}

export interface IArticleEditDto {
    id: number | undefined;
    title: string | undefined;
    content: string | undefined;
    topicId: number;
}

export class ArticleEditOutputDto implements IArticleEditOutputDto {
    article!: ArticleEditDto;
    topicTags!: TopicTagListDto[] | undefined;
    assignedTags!: number[] | undefined;

    constructor(data?: IArticleEditOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.article = _data["article"] ? ArticleEditDto.fromJS(_data["article"]) : <any>undefined;
            if (Array.isArray(_data["topicTags"])) {
                this.topicTags = [] as any;
                for (let item of _data["topicTags"])
                    this.topicTags!.push(TopicTagListDto.fromJS(item));
            }
            if (Array.isArray(_data["assignedTags"])) {
                this.assignedTags = [] as any;
                for (let item of _data["assignedTags"])
                    this.assignedTags!.push(item);
            }
        }
    }

    static fromJS(data: any): ArticleEditOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleEditOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        if (Array.isArray(this.topicTags)) {
            data["topicTags"] = [];
            for (let item of this.topicTags)
                data["topicTags"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedTags)) {
            data["assignedTags"] = [];
            for (let item of this.assignedTags)
                data["assignedTags"].push(item);
        }
        return data;
    }
}

export interface IArticleEditOutputDto {
    article: ArticleEditDto;
    topicTags: TopicTagListDto[] | undefined;
    assignedTags: number[] | undefined;
}

export class ArticleListDto implements IArticleListDto {
    id!: number;
    title!: string | undefined;
    creatorUser!: string | undefined;
    creationTime!: Date;

    constructor(data?: IArticleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.creatorUser = _data["creatorUser"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ArticleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["creatorUser"] = this.creatorUser;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IArticleListDto {
    id: number;
    title: string | undefined;
    creatorUser: string | undefined;
    creationTime: Date;
}

export class ArticleListDtoPagedResultDto implements IArticleListDtoPagedResultDto {
    items!: ArticleListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IArticleListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ArticleListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ArticleListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IArticleListDtoPagedResultDto {
    items: ArticleListDto[] | undefined;
    totalCount: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    rememberClient!: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string;
    encryptedAccessToken!: string;
    expireInSeconds!: number;
    userId!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    userId: number;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme!: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class CheckQitemForDuplicateInputDto implements ICheckQitemForDuplicateInputDto {
    id!: number;
    qText!: string;
    option1!: string;
    option2!: string;
    option3!: string;
    option4!: string;
    includeOptions!: boolean;

    constructor(data?: ICheckQitemForDuplicateInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qText = _data["qText"];
            this.option1 = _data["option1"];
            this.option2 = _data["option2"];
            this.option3 = _data["option3"];
            this.option4 = _data["option4"];
            this.includeOptions = _data["includeOptions"];
        }
    }

    static fromJS(data: any): CheckQitemForDuplicateInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckQitemForDuplicateInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qText"] = this.qText;
        data["option1"] = this.option1;
        data["option2"] = this.option2;
        data["option3"] = this.option3;
        data["option4"] = this.option4;
        data["includeOptions"] = this.includeOptions;
        return data;
    }
}

export interface ICheckQitemForDuplicateInputDto {
    id: number;
    qText: string;
    option1: string;
    option2: string;
    option3: string;
    option4: string;
    includeOptions: boolean;
}

export class CourseCreateDto implements ICourseCreateDto {
    id!: string;
    academyId!: string;
    name!: string;
    description!: string;
    keywords!: string | undefined;
    icon!: string | undefined;
    topicId!: number;
    isPublic!: boolean;
    courseDetails!: CourseDetailDto[] | undefined;

    constructor(data?: ICourseCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.academyId = _data["academyId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.keywords = _data["keywords"];
            this.icon = _data["icon"];
            this.topicId = _data["topicId"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["courseDetails"])) {
                this.courseDetails = [] as any;
                for (let item of _data["courseDetails"])
                    this.courseDetails!.push(CourseDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["academyId"] = this.academyId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["keywords"] = this.keywords;
        data["icon"] = this.icon;
        data["topicId"] = this.topicId;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.courseDetails)) {
            data["courseDetails"] = [];
            for (let item of this.courseDetails)
                data["courseDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICourseCreateDto {
    id: string;
    academyId: string;
    name: string;
    description: string;
    keywords: string | undefined;
    icon: string | undefined;
    topicId: number;
    isPublic: boolean;
    courseDetails: CourseDetailDto[] | undefined;
}

export class CourseDetailDto implements ICourseDetailDto {
    id!: number;
    courseId!: string;
    topicId!: number;
    title!: string | undefined;
    parentId!: number | undefined;
    topicOrder!: number;
    weightage!: number;
    level!: number;
    isAvailableByDate!: boolean;
    isAvailableOnPrevComp!: boolean;
    availableDate!: Date | undefined;

    constructor(data?: ICourseDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseId = _data["courseId"];
            this.topicId = _data["topicId"];
            this.title = _data["title"];
            this.parentId = _data["parentId"];
            this.topicOrder = _data["topicOrder"];
            this.weightage = _data["weightage"];
            this.level = _data["level"];
            this.isAvailableByDate = _data["isAvailableByDate"];
            this.isAvailableOnPrevComp = _data["isAvailableOnPrevComp"];
            this.availableDate = _data["availableDate"] ? new Date(_data["availableDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CourseDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseId"] = this.courseId;
        data["topicId"] = this.topicId;
        data["title"] = this.title;
        data["parentId"] = this.parentId;
        data["topicOrder"] = this.topicOrder;
        data["weightage"] = this.weightage;
        data["level"] = this.level;
        data["isAvailableByDate"] = this.isAvailableByDate;
        data["isAvailableOnPrevComp"] = this.isAvailableOnPrevComp;
        data["availableDate"] = this.availableDate ? this.availableDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICourseDetailDto {
    id: number;
    courseId: string;
    topicId: number;
    title: string | undefined;
    parentId: number | undefined;
    topicOrder: number;
    weightage: number;
    level: number;
    isAvailableByDate: boolean;
    isAvailableOnPrevComp: boolean;
    availableDate: Date | undefined;
}

export class CourseListDto implements ICourseListDto {
    id!: string;
    name!: string | undefined;
    description!: string | undefined;
    icon!: string | undefined;
    rating!: string | undefined;

    constructor(data?: ICourseListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.rating = _data["rating"];
        }
    }

    static fromJS(data: any): CourseListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["rating"] = this.rating;
        return data;
    }
}

export interface ICourseListDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
    icon: string | undefined;
    rating: string | undefined;
}

export class CourseListDtoListResultDto implements ICourseListDtoListResultDto {
    items!: CourseListDto[] | undefined;

    constructor(data?: ICourseListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CourseListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICourseListDtoListResultDto {
    items: CourseListDto[] | undefined;
}

export class CreateAnalyticInputDto implements ICreateAnalyticInputDto {
    msg!: string | undefined;

    constructor(data?: ICreateAnalyticInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.msg = _data["msg"];
        }
    }

    static fromJS(data: any): CreateAnalyticInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAnalyticInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msg"] = this.msg;
        return data;
    }
}

export interface ICreateAnalyticInputDto {
    msg: string | undefined;
}

export class CreateArticleInputDto implements ICreateArticleInputDto {
    topicId!: number;
    title!: string;
    content!: string;
    tagIds!: number[] | undefined;

    constructor(data?: ICreateArticleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["topicId"];
            this.title = _data["title"];
            this.content = _data["content"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateArticleInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateArticleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicId"] = this.topicId;
        data["title"] = this.title;
        data["content"] = this.content;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        return data;
    }
}

export interface ICreateArticleInputDto {
    topicId: number;
    title: string;
    content: string;
    tagIds: number[] | undefined;
}

export class CreateEditTSRInputDto implements ICreateEditTSRInputDto {
    id!: number;
    name!: string;
    description!: string;
    topicId!: number;

    constructor(data?: ICreateEditTSRInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.topicId = _data["topicId"];
        }
    }

    static fromJS(data: any): CreateEditTSRInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEditTSRInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["topicId"] = this.topicId;
        return data;
    }
}

export interface ICreateEditTSRInputDto {
    id: number;
    name: string;
    description: string;
    topicId: number;
}

export class CreateEditionDto implements ICreateEditionDto {
    name!: string;
    displayName!: string;
    assignedFeatures!: NameValueDto[] | undefined;

    constructor(data?: ICreateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["assignedFeatures"])) {
                this.assignedFeatures = [] as any;
                for (let item of _data["assignedFeatures"])
                    this.assignedFeatures!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.assignedFeatures)) {
            data["assignedFeatures"] = [];
            for (let item of this.assignedFeatures)
                data["assignedFeatures"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateEditionDto {
    name: string;
    displayName: string;
    assignedFeatures: NameValueDto[] | undefined;
}

export class CreateQItemInputDto implements ICreateQItemInputDto {
    topicId!: number;
    qText!: string;
    option1!: string;
    option2!: string;
    option3!: string;
    option4!: string;
    answer!: number;
    difficulty!: number;
    discrimination!: number;
    guessing!: number;
    source!: string | undefined;
    hint!: string | undefined;
    solution!: string | undefined;
    isVerified!: boolean;
    isInProd!: boolean;
    tagIds!: number[] | undefined;
    tsrId!: number;

    constructor(data?: ICreateQItemInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["topicId"];
            this.qText = _data["qText"];
            this.option1 = _data["option1"];
            this.option2 = _data["option2"];
            this.option3 = _data["option3"];
            this.option4 = _data["option4"];
            this.answer = _data["answer"];
            this.difficulty = _data["difficulty"];
            this.discrimination = _data["discrimination"];
            this.guessing = _data["guessing"];
            this.source = _data["source"];
            this.hint = _data["hint"];
            this.solution = _data["solution"];
            this.isVerified = _data["isVerified"];
            this.isInProd = _data["isInProd"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            this.tsrId = _data["tsrId"];
        }
    }

    static fromJS(data: any): CreateQItemInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQItemInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicId"] = this.topicId;
        data["qText"] = this.qText;
        data["option1"] = this.option1;
        data["option2"] = this.option2;
        data["option3"] = this.option3;
        data["option4"] = this.option4;
        data["answer"] = this.answer;
        data["difficulty"] = this.difficulty;
        data["discrimination"] = this.discrimination;
        data["guessing"] = this.guessing;
        data["source"] = this.source;
        data["hint"] = this.hint;
        data["solution"] = this.solution;
        data["isVerified"] = this.isVerified;
        data["isInProd"] = this.isInProd;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["tsrId"] = this.tsrId;
        return data;
    }
}

export interface ICreateQItemInputDto {
    topicId: number;
    qText: string;
    option1: string;
    option2: string;
    option3: string;
    option4: string;
    answer: number;
    difficulty: number;
    discrimination: number;
    guessing: number;
    source: string | undefined;
    hint: string | undefined;
    solution: string | undefined;
    isVerified: boolean;
    isInProd: boolean;
    tagIds: number[] | undefined;
    tsrId: number;
}

export class CreateRoleDto implements ICreateRoleDto {
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    connectionString!: string | undefined;
    isActive!: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class CreateTopicInputDto implements ICreateTopicInputDto {
    title!: string;
    description!: string | undefined;
    parentId!: number | undefined;

    constructor(data?: ICreateTopicInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): CreateTopicInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTopicInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface ICreateTopicInputDto {
    title: string;
    description: string | undefined;
    parentId: number | undefined;
}

export class CreateTopicTagInputDto implements ICreateTopicTagInputDto {
    id!: number;
    topicId!: number;
    name!: string;
    description!: string | undefined;

    constructor(data?: ICreateTopicTagInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.topicId = _data["topicId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateTopicTagInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTopicTagInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["topicId"] = this.topicId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateTopicTagInputDto {
    id: number;
    topicId: number;
    name: string;
    description: string | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    userName!: string;
    name!: string;
    surname!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    roleName!: string;
    password!: string;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.roleName = _data["roleName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["roleName"] = this.roleName;
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    roleName: string;
    password: string;
}

export class DRQuestionDetailDto implements IDRQuestionDetailDto {
    lqEvalId!: number;
    qEvalID!: string | undefined;
    selectedAnswer!: number;
    isSkipped!: boolean;
    isCorrect!: boolean;
    responseTime!: number;
    topicId!: number;
    topicTitle!: string | undefined;
    qId!: number;
    qText!: string | undefined;
    option1!: string | undefined;
    option2!: string | undefined;
    option3!: string | undefined;
    option4!: string | undefined;
    a!: number;
    hint!: string | undefined;
    tags!: string | undefined;
    isBookmarked!: boolean;
    isSillyMistake!: boolean;
    isDoubt!: boolean;
    solution!: string | undefined;

    constructor(data?: IDRQuestionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lqEvalId = _data["lqEvalId"];
            this.qEvalID = _data["qEvalID"];
            this.selectedAnswer = _data["selectedAnswer"];
            this.isSkipped = _data["isSkipped"];
            this.isCorrect = _data["isCorrect"];
            this.responseTime = _data["responseTime"];
            this.topicId = _data["topicId"];
            this.topicTitle = _data["topicTitle"];
            this.qId = _data["qId"];
            this.qText = _data["qText"];
            this.option1 = _data["option1"];
            this.option2 = _data["option2"];
            this.option3 = _data["option3"];
            this.option4 = _data["option4"];
            this.a = _data["a"];
            this.hint = _data["hint"];
            this.tags = _data["tags"];
            this.isBookmarked = _data["isBookmarked"];
            this.isSillyMistake = _data["isSillyMistake"];
            this.isDoubt = _data["isDoubt"];
            this.solution = _data["solution"];
        }
    }

    static fromJS(data: any): DRQuestionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new DRQuestionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lqEvalId"] = this.lqEvalId;
        data["qEvalID"] = this.qEvalID;
        data["selectedAnswer"] = this.selectedAnswer;
        data["isSkipped"] = this.isSkipped;
        data["isCorrect"] = this.isCorrect;
        data["responseTime"] = this.responseTime;
        data["topicId"] = this.topicId;
        data["topicTitle"] = this.topicTitle;
        data["qId"] = this.qId;
        data["qText"] = this.qText;
        data["option1"] = this.option1;
        data["option2"] = this.option2;
        data["option3"] = this.option3;
        data["option4"] = this.option4;
        data["a"] = this.a;
        data["hint"] = this.hint;
        data["tags"] = this.tags;
        data["isBookmarked"] = this.isBookmarked;
        data["isSillyMistake"] = this.isSillyMistake;
        data["isDoubt"] = this.isDoubt;
        data["solution"] = this.solution;
        return data;
    }
}

export interface IDRQuestionDetailDto {
    lqEvalId: number;
    qEvalID: string | undefined;
    selectedAnswer: number;
    isSkipped: boolean;
    isCorrect: boolean;
    responseTime: number;
    topicId: number;
    topicTitle: string | undefined;
    qId: number;
    qText: string | undefined;
    option1: string | undefined;
    option2: string | undefined;
    option3: string | undefined;
    option4: string | undefined;
    a: number;
    hint: string | undefined;
    tags: string | undefined;
    isBookmarked: boolean;
    isSillyMistake: boolean;
    isDoubt: boolean;
    solution: string | undefined;
}

export class DoubtDto implements IDoubtDto {
    id!: number;
    courseName!: string;
    qItemId!: number;
    qText!: string;
    topicId!: number;
    topicTitle!: string;
    tags!: TopicTagListDto[] | undefined;

    constructor(data?: IDoubtDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseName = _data["courseName"];
            this.qItemId = _data["qItemId"];
            this.qText = _data["qText"];
            this.topicId = _data["topicId"];
            this.topicTitle = _data["topicTitle"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TopicTagListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DoubtDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoubtDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseName"] = this.courseName;
        data["qItemId"] = this.qItemId;
        data["qText"] = this.qText;
        data["topicId"] = this.topicId;
        data["topicTitle"] = this.topicTitle;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDoubtDto {
    id: number;
    courseName: string;
    qItemId: number;
    qText: string;
    topicId: number;
    topicTitle: string;
    tags: TopicTagListDto[] | undefined;
}

export class DoubtDtoListResultDto implements IDoubtDtoListResultDto {
    items!: DoubtDto[] | undefined;

    constructor(data?: IDoubtDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DoubtDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DoubtDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoubtDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDoubtDtoListResultDto {
    items: DoubtDto[] | undefined;
}

export class EditionDto implements IEditionDto {
    id!: number;
    name!: string;
    displayName!: string;

    constructor(data?: IEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): EditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IEditionDto {
    id: number;
    name: string;
    displayName: string;
}

export class EditionDtoPagedResultDto implements IEditionDtoPagedResultDto {
    items!: EditionDto[] | undefined;
    totalCount!: number;

    constructor(data?: IEditionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EditionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EditionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IEditionDtoPagedResultDto {
    items: EditionDto[] | undefined;
    totalCount: number;
}

export class EntityDto implements IEntityDto {
    id!: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDto {
    id: number;
}

export class FMapDto implements IFMapDto {
    id!: string;
    title!: string;
    description!: string | undefined;
    profileImageLink!: string | undefined;
    topicId!: number;
    topic!: TopicDto;
    courseID!: string;
    goalId!: number;
    goal!: string | undefined;
    creatorUser!: string | undefined;
    isPublic!: boolean;
    mapTopics!: TopicMapItem[] | undefined;

    constructor(data?: IFMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.profileImageLink = _data["profileImageLink"];
            this.topicId = _data["topicId"];
            this.topic = _data["topic"] ? TopicDto.fromJS(_data["topic"]) : <any>undefined;
            this.courseID = _data["courseID"];
            this.goalId = _data["goalId"];
            this.goal = _data["goal"];
            this.creatorUser = _data["creatorUser"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["mapTopics"])) {
                this.mapTopics = [] as any;
                for (let item of _data["mapTopics"])
                    this.mapTopics!.push(TopicMapItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new FMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["profileImageLink"] = this.profileImageLink;
        data["topicId"] = this.topicId;
        data["topic"] = this.topic ? this.topic.toJSON() : <any>undefined;
        data["courseID"] = this.courseID;
        data["goalId"] = this.goalId;
        data["goal"] = this.goal;
        data["creatorUser"] = this.creatorUser;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.mapTopics)) {
            data["mapTopics"] = [];
            for (let item of this.mapTopics)
                data["mapTopics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFMapDto {
    id: string;
    title: string;
    description: string | undefined;
    profileImageLink: string | undefined;
    topicId: number;
    topic: TopicDto;
    courseID: string;
    goalId: number;
    goal: string | undefined;
    creatorUser: string | undefined;
    isPublic: boolean;
    mapTopics: TopicMapItem[] | undefined;
}

export class FMapDtoListResultDto implements IFMapDtoListResultDto {
    items!: FMapDto[] | undefined;

    constructor(data?: IFMapDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FMapDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FMapDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFMapDtoListResultDto {
    items: FMapDto[] | undefined;
}

export class FMapDtoPagedResultDto implements IFMapDtoPagedResultDto {
    items!: FMapDto[] | undefined;
    totalCount!: number;

    constructor(data?: IFMapDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FMapDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): FMapDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FMapDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IFMapDtoPagedResultDto {
    items: FMapDto[] | undefined;
    totalCount: number;
}

export class FMapInit implements IFMapInit {
    courseId!: string | undefined;
    topicId!: number;
    canCreateNew!: boolean;
    myFMaps!: FMapDtoListResultDto;
    sponsoredFMaps!: FMapDtoListResultDto;
    searchResultFMaps!: FMapDtoPagedResultDto;

    constructor(data?: IFMapInit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.topicId = _data["topicId"];
            this.canCreateNew = _data["canCreateNew"];
            this.myFMaps = _data["myFMaps"] ? FMapDtoListResultDto.fromJS(_data["myFMaps"]) : <any>undefined;
            this.sponsoredFMaps = _data["sponsoredFMaps"] ? FMapDtoListResultDto.fromJS(_data["sponsoredFMaps"]) : <any>undefined;
            this.searchResultFMaps = _data["searchResultFMaps"] ? FMapDtoPagedResultDto.fromJS(_data["searchResultFMaps"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FMapInit {
        data = typeof data === 'object' ? data : {};
        let result = new FMapInit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["topicId"] = this.topicId;
        data["canCreateNew"] = this.canCreateNew;
        data["myFMaps"] = this.myFMaps ? this.myFMaps.toJSON() : <any>undefined;
        data["sponsoredFMaps"] = this.sponsoredFMaps ? this.sponsoredFMaps.toJSON() : <any>undefined;
        data["searchResultFMaps"] = this.searchResultFMaps ? this.searchResultFMaps.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFMapInit {
    courseId: string | undefined;
    topicId: number;
    canCreateNew: boolean;
    myFMaps: FMapDtoListResultDto;
    sponsoredFMaps: FMapDtoListResultDto;
    searchResultFMaps: FMapDtoPagedResultDto;
}

export class FMapItemDto implements IFMapItemDto {
    id!: number;
    fMapId!: string;
    topicResourceId!: number;
    topicResource!: TopicResourceDto;

    constructor(data?: IFMapItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fMapId = _data["fMapId"];
            this.topicResourceId = _data["topicResourceId"];
            this.topicResource = _data["topicResource"] ? TopicResourceDto.fromJS(_data["topicResource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FMapItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FMapItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fMapId"] = this.fMapId;
        data["topicResourceId"] = this.topicResourceId;
        data["topicResource"] = this.topicResource ? this.topicResource.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFMapItemDto {
    id: number;
    fMapId: string;
    topicResourceId: number;
    topicResource: TopicResourceDto;
}

export class FeatureDto implements IFeatureDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    value!: string | undefined;
    inputType!: IInputType;

    constructor(data?: IFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.value = _data["value"];
            this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["value"] = this.value;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeatureDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    value: string | undefined;
    inputType: IInputType;
}

export class FeatureDtoListResultDto implements IFeatureDtoListResultDto {
    items!: FeatureDto[] | undefined;

    constructor(data?: IFeatureDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeatureDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFeatureDtoListResultDto {
    items: FeatureDto[] | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class FriendsDto implements IFriendsDto {
    name!: string | undefined;

    constructor(data?: IFriendsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FriendsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FriendsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IFriendsDto {
    name: string | undefined;
}

export class FriendsDtoListResultDto implements IFriendsDtoListResultDto {
    items!: FriendsDto[] | undefined;

    constructor(data?: IFriendsDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FriendsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FriendsDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FriendsDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFriendsDtoListResultDto {
    items: FriendsDto[] | undefined;
}

export class GetAcademyOutputDto implements IGetAcademyOutputDto {
    id!: string;
    name!: string;
    grades!: NameValueDto[] | undefined;

    constructor(data?: IGetAcademyOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["grades"])) {
                this.grades = [] as any;
                for (let item of _data["grades"])
                    this.grades!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAcademyOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcademyOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.grades)) {
            data["grades"] = [];
            for (let item of this.grades)
                data["grades"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAcademyOutputDto {
    id: string;
    name: string;
    grades: NameValueDto[] | undefined;
}

export class GetAcademyOutputDtoListResultDto implements IGetAcademyOutputDtoListResultDto {
    items!: GetAcademyOutputDto[] | undefined;

    constructor(data?: IGetAcademyOutputDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAcademyOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAcademyOutputDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcademyOutputDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAcademyOutputDtoListResultDto {
    items: GetAcademyOutputDto[] | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application!: ApplicationInfoDto;
    user!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class GetEditionForEditOutputDto implements IGetEditionForEditOutputDto {
    edition!: EditionDto;
    features!: NameValueDto[] | undefined;

    constructor(data?: IGetEditionForEditOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionForEditOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionForEditOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionForEditOutputDto {
    edition: EditionDto;
    features: NameValueDto[] | undefined;
}

export class GetFMapsInputDto implements IGetFMapsInputDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    courseID!: string;
    topicId!: number;
    fMapId!: string;
    filter!: string | undefined;

    constructor(data?: IGetFMapsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.courseID = _data["courseID"];
            this.topicId = _data["topicId"];
            this.fMapId = _data["fMapId"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): GetFMapsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFMapsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["courseID"] = this.courseID;
        data["topicId"] = this.topicId;
        data["fMapId"] = this.fMapId;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IGetFMapsInputDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    courseID: string;
    topicId: number;
    fMapId: string;
    filter: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetUserForEditOutputDto implements IGetUserForEditOutputDto {
    user!: UserEditDto;
    roles!: UserRoleDto[];

    constructor(data?: IGetUserForEditOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : new UserEditDto();
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserForEditOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserForEditOutputDto {
    user: UserEditDto;
    roles: UserRoleDto[];
}

export class GoalSubjectDto implements IGoalSubjectDto {
    id!: number;
    mark!: number;
    tutionName!: string | undefined;
    fees!: number;

    constructor(data?: IGoalSubjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mark = _data["mark"];
            this.tutionName = _data["tutionName"];
            this.fees = _data["fees"];
        }
    }

    static fromJS(data: any): GoalSubjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoalSubjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mark"] = this.mark;
        data["tutionName"] = this.tutionName;
        data["fees"] = this.fees;
        return data;
    }
}

export interface IGoalSubjectDto {
    id: number;
    mark: number;
    tutionName: string | undefined;
    fees: number;
}

export class GroupedTagsDto implements IGroupedTagsDto {
    topic!: TopicTagListDto;
    topicTags!: TopicTagListDto[] | undefined;

    constructor(data?: IGroupedTagsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topic = _data["topic"] ? TopicTagListDto.fromJS(_data["topic"]) : <any>undefined;
            if (Array.isArray(_data["topicTags"])) {
                this.topicTags = [] as any;
                for (let item of _data["topicTags"])
                    this.topicTags!.push(TopicTagListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupedTagsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedTagsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topic"] = this.topic ? this.topic.toJSON() : <any>undefined;
        if (Array.isArray(this.topicTags)) {
            data["topicTags"] = [];
            for (let item of this.topicTags)
                data["topicTags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroupedTagsDto {
    topic: TopicTagListDto;
    topicTags: TopicTagListDto[] | undefined;
}

export class GuidAcademyClassCourseDto implements IGuidAcademyClassCourseDto {
    id!: string;
    name!: string | undefined;
    progress!: number;
    readiness!: number;

    constructor(data?: IGuidAcademyClassCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.progress = _data["progress"];
            this.readiness = _data["readiness"];
        }
    }

    static fromJS(data: any): GuidAcademyClassCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuidAcademyClassCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["progress"] = this.progress;
        data["readiness"] = this.readiness;
        return data;
    }
}

export interface IGuidAcademyClassCourseDto {
    id: string;
    name: string | undefined;
    progress: number;
    readiness: number;
}

export class GuidAcademyClassCourseDtoListResultDto implements IGuidAcademyClassCourseDtoListResultDto {
    items!: GuidAcademyClassCourseDto[] | undefined;

    constructor(data?: IGuidAcademyClassCourseDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GuidAcademyClassCourseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GuidAcademyClassCourseDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuidAcademyClassCourseDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGuidAcademyClassCourseDtoListResultDto {
    items: GuidAcademyClassCourseDto[] | undefined;
}

export class GuidNameValueDto implements IGuidNameValueDto {
    name!: string | undefined;
    value!: string;

    constructor(data?: IGuidNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GuidNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuidNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IGuidNameValueDto {
    name: string | undefined;
    value: string;
}

export class GuidNameValueDtoListResultDto implements IGuidNameValueDtoListResultDto {
    items!: GuidNameValueDto[] | undefined;

    constructor(data?: IGuidNameValueDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GuidNameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GuidNameValueDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuidNameValueDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGuidNameValueDtoListResultDto {
    items: GuidNameValueDto[] | undefined;
}

export class IInputType implements IIInputType {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>(<any>this).attributes)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        data = typeof data === 'object' ? data : {};
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
}

export class IValueValidator implements IIValueValidator {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>(<any>this).attributes)![key] = _data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        return data;
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
}

export class Int32AcademyClassDto implements IInt32AcademyClassDto {
    id!: number;
    name!: string | undefined;
    progress!: number;
    readiness!: number;

    constructor(data?: IInt32AcademyClassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.progress = _data["progress"];
            this.readiness = _data["readiness"];
        }
    }

    static fromJS(data: any): Int32AcademyClassDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int32AcademyClassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["progress"] = this.progress;
        data["readiness"] = this.readiness;
        return data;
    }
}

export interface IInt32AcademyClassDto {
    id: number;
    name: string | undefined;
    progress: number;
    readiness: number;
}

export class Int32AcademyClassDtoListResultDto implements IInt32AcademyClassDtoListResultDto {
    items!: Int32AcademyClassDto[] | undefined;

    constructor(data?: IInt32AcademyClassDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Int32AcademyClassDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Int32AcademyClassDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int32AcademyClassDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInt32AcademyClassDtoListResultDto {
    items: Int32AcademyClassDto[] | undefined;
}

export class Int32NameValue implements IInt32NameValue {
    name!: string | undefined;
    value!: number;

    constructor(data?: IInt32NameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Int32NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new Int32NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IInt32NameValue {
    name: string | undefined;
    value: number;
}

export class Int32NameValueListResultDto implements IInt32NameValueListResultDto {
    items!: Int32NameValue[] | undefined;

    constructor(data?: IInt32NameValueListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Int32NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Int32NameValueListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int32NameValueListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInt32NameValueListResultDto {
    items: Int32NameValue[] | undefined;
}

export class Int32ReadinessDto implements IInt32ReadinessDto {
    id!: number;
    name!: string | undefined;
    progress!: number;
    readiness!: number;

    constructor(data?: IInt32ReadinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.progress = _data["progress"];
            this.readiness = _data["readiness"];
        }
    }

    static fromJS(data: any): Int32ReadinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int32ReadinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["progress"] = this.progress;
        data["readiness"] = this.readiness;
        return data;
    }
}

export interface IInt32ReadinessDto {
    id: number;
    name: string | undefined;
    progress: number;
    readiness: number;
}

export class Int32ReadinessDtoListResultDto implements IInt32ReadinessDtoListResultDto {
    items!: Int32ReadinessDto[] | undefined;

    constructor(data?: IInt32ReadinessDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Int32ReadinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Int32ReadinessDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int32ReadinessDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInt32ReadinessDtoListResultDto {
    items: Int32ReadinessDto[] | undefined;
}

export class Int64EntityDto implements IInt64EntityDto {
    id!: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class LearnerTopicEvalDto implements ILearnerTopicEvalDto {
    evalID!: number;
    courseTopicId!: number;
    qEvalID!: string | undefined;
    title!: string | undefined;
    topicId!: number;
    startedOn!: Date;
    progress!: number;
    isCompleted!: boolean;

    constructor(data?: ILearnerTopicEvalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evalID = _data["evalID"];
            this.courseTopicId = _data["courseTopicId"];
            this.qEvalID = _data["qEvalID"];
            this.title = _data["title"];
            this.topicId = _data["topicId"];
            this.startedOn = _data["startedOn"] ? new Date(_data["startedOn"].toString()) : <any>undefined;
            this.progress = _data["progress"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): LearnerTopicEvalDto {
        data = typeof data === 'object' ? data : {};
        let result = new LearnerTopicEvalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evalID"] = this.evalID;
        data["courseTopicId"] = this.courseTopicId;
        data["qEvalID"] = this.qEvalID;
        data["title"] = this.title;
        data["topicId"] = this.topicId;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>undefined;
        data["progress"] = this.progress;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface ILearnerTopicEvalDto {
    evalID: number;
    courseTopicId: number;
    qEvalID: string | undefined;
    title: string | undefined;
    topicId: number;
    startedOn: Date;
    progress: number;
    isCompleted: boolean;
}

export class LearnerTopicEvalDtoListResultDto implements ILearnerTopicEvalDtoListResultDto {
    items!: LearnerTopicEvalDto[] | undefined;

    constructor(data?: ILearnerTopicEvalDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LearnerTopicEvalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LearnerTopicEvalDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LearnerTopicEvalDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILearnerTopicEvalDtoListResultDto {
    items: LearnerTopicEvalDto[] | undefined;
}

export class NameValueDto implements INameValueDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class PRTopicOutputDto implements IPRTopicOutputDto {
    courseTopicId!: number;
    title!: string | undefined;
    startDate!: Date;
    classId!: number;
    professorId!: number;
    professorName!: string | undefined;
    grade!: string | undefined;
    section!: string;
    totalLearners!: number;
    notCompleted!: number;
    completed!: number;

    constructor(data?: IPRTopicOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseTopicId = _data["courseTopicId"];
            this.title = _data["title"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.classId = _data["classId"];
            this.professorId = _data["professorId"];
            this.professorName = _data["professorName"];
            this.grade = _data["grade"];
            this.section = _data["section"];
            this.totalLearners = _data["totalLearners"];
            this.notCompleted = _data["notCompleted"];
            this.completed = _data["completed"];
        }
    }

    static fromJS(data: any): PRTopicOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PRTopicOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseTopicId"] = this.courseTopicId;
        data["title"] = this.title;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["classId"] = this.classId;
        data["professorId"] = this.professorId;
        data["professorName"] = this.professorName;
        data["grade"] = this.grade;
        data["section"] = this.section;
        data["totalLearners"] = this.totalLearners;
        data["notCompleted"] = this.notCompleted;
        data["completed"] = this.completed;
        return data;
    }
}

export interface IPRTopicOutputDto {
    courseTopicId: number;
    title: string | undefined;
    startDate: Date;
    classId: number;
    professorId: number;
    professorName: string | undefined;
    grade: string | undefined;
    section: string;
    totalLearners: number;
    notCompleted: number;
    completed: number;
}

export class PRTopicOutputDtoListResultDto implements IPRTopicOutputDtoListResultDto {
    items!: PRTopicOutputDto[] | undefined;

    constructor(data?: IPRTopicOutputDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PRTopicOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PRTopicOutputDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PRTopicOutputDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPRTopicOutputDtoListResultDto {
    items: PRTopicOutputDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items!: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class QCountListDto implements IQCountListDto {
    id!: number;
    parentId!: number;
    title!: string | undefined;
    tagName!: string | undefined;
    tagId!: number;
    qCount!: number;
    avgDifficulty!: number | undefined;
    qAsk!: number;
    weightage!: number;
    qProdCount!: number;

    constructor(data?: IQCountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.title = _data["title"];
            this.tagName = _data["tagName"];
            this.tagId = _data["tagId"];
            this.qCount = _data["qCount"];
            this.avgDifficulty = _data["avgDifficulty"];
            this.qAsk = _data["qAsk"];
            this.weightage = _data["weightage"];
            this.qProdCount = _data["qProdCount"];
        }
    }

    static fromJS(data: any): QCountListDto {
        data = typeof data === 'object' ? data : {};
        let result = new QCountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["tagName"] = this.tagName;
        data["tagId"] = this.tagId;
        data["qCount"] = this.qCount;
        data["avgDifficulty"] = this.avgDifficulty;
        data["qAsk"] = this.qAsk;
        data["weightage"] = this.weightage;
        data["qProdCount"] = this.qProdCount;
        return data;
    }
}

export interface IQCountListDto {
    id: number;
    parentId: number;
    title: string | undefined;
    tagName: string | undefined;
    tagId: number;
    qCount: number;
    avgDifficulty: number | undefined;
    qAsk: number;
    weightage: number;
    qProdCount: number;
}

export class QEvalDto implements IQEvalDto {
    evalID!: number;
    qEvalID!: string | undefined;
    title!: string | undefined;
    topicId!: number;
    evalItems!: QEvalItemsDto[] | undefined;

    constructor(data?: IQEvalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evalID = _data["evalID"];
            this.qEvalID = _data["qEvalID"];
            this.title = _data["title"];
            this.topicId = _data["topicId"];
            if (Array.isArray(_data["evalItems"])) {
                this.evalItems = [] as any;
                for (let item of _data["evalItems"])
                    this.evalItems!.push(QEvalItemsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QEvalDto {
        data = typeof data === 'object' ? data : {};
        let result = new QEvalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evalID"] = this.evalID;
        data["qEvalID"] = this.qEvalID;
        data["title"] = this.title;
        data["topicId"] = this.topicId;
        if (Array.isArray(this.evalItems)) {
            data["evalItems"] = [];
            for (let item of this.evalItems)
                data["evalItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQEvalDto {
    evalID: number;
    qEvalID: string | undefined;
    title: string | undefined;
    topicId: number;
    evalItems: QEvalItemsDto[] | undefined;
}

export class QEvalInputDto implements IQEvalInputDto {
    evalID!: number;
    topicId!: number;
    qId!: number;
    a!: number;
    selectedAns!: number;
    responseTime!: number;
    isSkipped!: boolean;

    constructor(data?: IQEvalInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evalID = _data["evalID"];
            this.topicId = _data["topicId"];
            this.qId = _data["qId"];
            this.a = _data["a"];
            this.selectedAns = _data["selectedAns"];
            this.responseTime = _data["responseTime"];
            this.isSkipped = _data["isSkipped"];
        }
    }

    static fromJS(data: any): QEvalInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QEvalInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evalID"] = this.evalID;
        data["topicId"] = this.topicId;
        data["qId"] = this.qId;
        data["a"] = this.a;
        data["selectedAns"] = this.selectedAns;
        data["responseTime"] = this.responseTime;
        data["isSkipped"] = this.isSkipped;
        return data;
    }
}

export interface IQEvalInputDto {
    evalID: number;
    topicId: number;
    qId: number;
    a: number;
    selectedAns: number;
    responseTime: number;
    isSkipped: boolean;
}

export class QEvalItemsDto implements IQEvalItemsDto {
    topicId!: number;
    qId!: number;
    qText!: string | undefined;
    option1!: string | undefined;
    option2!: string | undefined;
    option3!: string | undefined;
    option4!: string | undefined;
    a!: number;

    constructor(data?: IQEvalItemsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["topicId"];
            this.qId = _data["qId"];
            this.qText = _data["qText"];
            this.option1 = _data["option1"];
            this.option2 = _data["option2"];
            this.option3 = _data["option3"];
            this.option4 = _data["option4"];
            this.a = _data["a"];
        }
    }

    static fromJS(data: any): QEvalItemsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QEvalItemsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicId"] = this.topicId;
        data["qId"] = this.qId;
        data["qText"] = this.qText;
        data["option1"] = this.option1;
        data["option2"] = this.option2;
        data["option3"] = this.option3;
        data["option4"] = this.option4;
        data["a"] = this.a;
        return data;
    }
}

export interface IQEvalItemsDto {
    topicId: number;
    qId: number;
    qText: string | undefined;
    option1: string | undefined;
    option2: string | undefined;
    option3: string | undefined;
    option4: string | undefined;
    a: number;
}

export class QEvalReportDto implements IQEvalReportDto {
    title!: string | undefined;
    topicId!: number;
    report!: QEvalReportItemDto;
    reportDataByTag!: QReportDataByTagDto;
    reviewItems!: QEvalReviewItemDto[] | undefined;

    constructor(data?: IQEvalReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.topicId = _data["topicId"];
            this.report = _data["report"] ? QEvalReportItemDto.fromJS(_data["report"]) : <any>undefined;
            this.reportDataByTag = _data["reportDataByTag"] ? QReportDataByTagDto.fromJS(_data["reportDataByTag"]) : <any>undefined;
            if (Array.isArray(_data["reviewItems"])) {
                this.reviewItems = [] as any;
                for (let item of _data["reviewItems"])
                    this.reviewItems!.push(QEvalReviewItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QEvalReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new QEvalReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["topicId"] = this.topicId;
        data["report"] = this.report ? this.report.toJSON() : <any>undefined;
        data["reportDataByTag"] = this.reportDataByTag ? this.reportDataByTag.toJSON() : <any>undefined;
        if (Array.isArray(this.reviewItems)) {
            data["reviewItems"] = [];
            for (let item of this.reviewItems)
                data["reviewItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQEvalReportDto {
    title: string | undefined;
    topicId: number;
    report: QEvalReportItemDto;
    reportDataByTag: QReportDataByTagDto;
    reviewItems: QEvalReviewItemDto[] | undefined;
}

export class QEvalReportItemDto implements IQEvalReportItemDto {
    topicId!: number;
    parentId!: number;
    title!: string | undefined;
    strong!: boolean;
    strength!: number;
    avgResponseTime!: number;
    improveIn!: string | undefined;
    skipped!: string | undefined;
    subReports!: QEvalReportItemDto[] | undefined;

    constructor(data?: IQEvalReportItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["topicId"];
            this.parentId = _data["parentId"];
            this.title = _data["title"];
            this.strong = _data["strong"];
            this.strength = _data["strength"];
            this.avgResponseTime = _data["avgResponseTime"];
            this.improveIn = _data["improveIn"];
            this.skipped = _data["skipped"];
            if (Array.isArray(_data["subReports"])) {
                this.subReports = [] as any;
                for (let item of _data["subReports"])
                    this.subReports!.push(QEvalReportItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QEvalReportItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new QEvalReportItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicId"] = this.topicId;
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["strong"] = this.strong;
        data["strength"] = this.strength;
        data["avgResponseTime"] = this.avgResponseTime;
        data["improveIn"] = this.improveIn;
        data["skipped"] = this.skipped;
        if (Array.isArray(this.subReports)) {
            data["subReports"] = [];
            for (let item of this.subReports)
                data["subReports"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQEvalReportItemDto {
    topicId: number;
    parentId: number;
    title: string | undefined;
    strong: boolean;
    strength: number;
    avgResponseTime: number;
    improveIn: string | undefined;
    skipped: string | undefined;
    subReports: QEvalReportItemDto[] | undefined;
}

export class QEvalReviewDto implements IQEvalReviewDto {
    qEvalID!: string | undefined;
    title!: string | undefined;
    topicId!: number;
    reviewItems!: QEvalReviewItemDto[] | undefined;

    constructor(data?: IQEvalReviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qEvalID = _data["qEvalID"];
            this.title = _data["title"];
            this.topicId = _data["topicId"];
            if (Array.isArray(_data["reviewItems"])) {
                this.reviewItems = [] as any;
                for (let item of _data["reviewItems"])
                    this.reviewItems!.push(QEvalReviewItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QEvalReviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new QEvalReviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qEvalID"] = this.qEvalID;
        data["title"] = this.title;
        data["topicId"] = this.topicId;
        if (Array.isArray(this.reviewItems)) {
            data["reviewItems"] = [];
            for (let item of this.reviewItems)
                data["reviewItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQEvalReviewDto {
    qEvalID: string | undefined;
    title: string | undefined;
    topicId: number;
    reviewItems: QEvalReviewItemDto[] | undefined;
}

export class QEvalReviewItemDto implements IQEvalReviewItemDto {
    lqEvalId!: number;
    qEvalID!: string | undefined;
    selectedAnswer!: number;
    isSkipped!: number;
    isCorrect!: number;
    responseTime!: number;
    topicId!: number;
    topicTitle!: string | undefined;
    qId!: number;
    qText!: string | undefined;
    option1!: string | undefined;
    option2!: string | undefined;
    option3!: string | undefined;
    option4!: string | undefined;
    a!: number;
    hint!: string | undefined;
    tags!: string | undefined;
    isBookmarked!: boolean;
    isSillyMistake!: boolean;
    isDoubt!: boolean;

    constructor(data?: IQEvalReviewItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lqEvalId = _data["lqEvalId"];
            this.qEvalID = _data["qEvalID"];
            this.selectedAnswer = _data["selectedAnswer"];
            this.isSkipped = _data["isSkipped"];
            this.isCorrect = _data["isCorrect"];
            this.responseTime = _data["responseTime"];
            this.topicId = _data["topicId"];
            this.topicTitle = _data["topicTitle"];
            this.qId = _data["qId"];
            this.qText = _data["qText"];
            this.option1 = _data["option1"];
            this.option2 = _data["option2"];
            this.option3 = _data["option3"];
            this.option4 = _data["option4"];
            this.a = _data["a"];
            this.hint = _data["hint"];
            this.tags = _data["tags"];
            this.isBookmarked = _data["isBookmarked"];
            this.isSillyMistake = _data["isSillyMistake"];
            this.isDoubt = _data["isDoubt"];
        }
    }

    static fromJS(data: any): QEvalReviewItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new QEvalReviewItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lqEvalId"] = this.lqEvalId;
        data["qEvalID"] = this.qEvalID;
        data["selectedAnswer"] = this.selectedAnswer;
        data["isSkipped"] = this.isSkipped;
        data["isCorrect"] = this.isCorrect;
        data["responseTime"] = this.responseTime;
        data["topicId"] = this.topicId;
        data["topicTitle"] = this.topicTitle;
        data["qId"] = this.qId;
        data["qText"] = this.qText;
        data["option1"] = this.option1;
        data["option2"] = this.option2;
        data["option3"] = this.option3;
        data["option4"] = this.option4;
        data["a"] = this.a;
        data["hint"] = this.hint;
        data["tags"] = this.tags;
        data["isBookmarked"] = this.isBookmarked;
        data["isSillyMistake"] = this.isSillyMistake;
        data["isDoubt"] = this.isDoubt;
        return data;
    }
}

export interface IQEvalReviewItemDto {
    lqEvalId: number;
    qEvalID: string | undefined;
    selectedAnswer: number;
    isSkipped: number;
    isCorrect: number;
    responseTime: number;
    topicId: number;
    topicTitle: string | undefined;
    qId: number;
    qText: string | undefined;
    option1: string | undefined;
    option2: string | undefined;
    option3: string | undefined;
    option4: string | undefined;
    a: number;
    hint: string | undefined;
    tags: string | undefined;
    isBookmarked: boolean;
    isSillyMistake: boolean;
    isDoubt: boolean;
}

export class QItemEditDto implements IQItemEditDto {
    id!: number | undefined;
    topicId!: number;
    qText!: string;
    option1!: string;
    option2!: string;
    option3!: string;
    option4!: string;
    answer!: number;
    difficulty!: number;
    discrimination!: number;
    guessing!: number;
    source!: string | undefined;
    hint!: string | undefined;
    solution!: string | undefined;
    tagIds!: number[] | undefined;
    tsrId!: number;
    isVerified!: boolean;
    isInProd!: boolean;

    constructor(data?: IQItemEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.topicId = _data["topicId"];
            this.qText = _data["qText"];
            this.option1 = _data["option1"];
            this.option2 = _data["option2"];
            this.option3 = _data["option3"];
            this.option4 = _data["option4"];
            this.answer = _data["answer"];
            this.difficulty = _data["difficulty"];
            this.discrimination = _data["discrimination"];
            this.guessing = _data["guessing"];
            this.source = _data["source"];
            this.hint = _data["hint"];
            this.solution = _data["solution"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            this.tsrId = _data["tsrId"];
            this.isVerified = _data["isVerified"];
            this.isInProd = _data["isInProd"];
        }
    }

    static fromJS(data: any): QItemEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new QItemEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["topicId"] = this.topicId;
        data["qText"] = this.qText;
        data["option1"] = this.option1;
        data["option2"] = this.option2;
        data["option3"] = this.option3;
        data["option4"] = this.option4;
        data["answer"] = this.answer;
        data["difficulty"] = this.difficulty;
        data["discrimination"] = this.discrimination;
        data["guessing"] = this.guessing;
        data["source"] = this.source;
        data["hint"] = this.hint;
        data["solution"] = this.solution;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["tsrId"] = this.tsrId;
        data["isVerified"] = this.isVerified;
        data["isInProd"] = this.isInProd;
        return data;
    }
}

export interface IQItemEditDto {
    id: number | undefined;
    topicId: number;
    qText: string;
    option1: string;
    option2: string;
    option3: string;
    option4: string;
    answer: number;
    difficulty: number;
    discrimination: number;
    guessing: number;
    source: string | undefined;
    hint: string | undefined;
    solution: string | undefined;
    tagIds: number[] | undefined;
    tsrId: number;
    isVerified: boolean;
    isInProd: boolean;
}

export class QItemEditOutputDto implements IQItemEditOutputDto {
    qItem!: QItemEditDto;
    topicTags!: TopicTagListDto[] | undefined;
    topicTSRs!: TopicTagListDto[] | undefined;
    assignedTags!: number[] | undefined;
    groupedTags!: GroupedTagsDto[] | undefined;
    topic!: TopicDto;

    constructor(data?: IQItemEditOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qItem = _data["qItem"] ? QItemEditDto.fromJS(_data["qItem"]) : <any>undefined;
            if (Array.isArray(_data["topicTags"])) {
                this.topicTags = [] as any;
                for (let item of _data["topicTags"])
                    this.topicTags!.push(TopicTagListDto.fromJS(item));
            }
            if (Array.isArray(_data["topicTSRs"])) {
                this.topicTSRs = [] as any;
                for (let item of _data["topicTSRs"])
                    this.topicTSRs!.push(TopicTagListDto.fromJS(item));
            }
            if (Array.isArray(_data["assignedTags"])) {
                this.assignedTags = [] as any;
                for (let item of _data["assignedTags"])
                    this.assignedTags!.push(item);
            }
            if (Array.isArray(_data["groupedTags"])) {
                this.groupedTags = [] as any;
                for (let item of _data["groupedTags"])
                    this.groupedTags!.push(GroupedTagsDto.fromJS(item));
            }
            this.topic = _data["topic"] ? TopicDto.fromJS(_data["topic"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QItemEditOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QItemEditOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qItem"] = this.qItem ? this.qItem.toJSON() : <any>undefined;
        if (Array.isArray(this.topicTags)) {
            data["topicTags"] = [];
            for (let item of this.topicTags)
                data["topicTags"].push(item.toJSON());
        }
        if (Array.isArray(this.topicTSRs)) {
            data["topicTSRs"] = [];
            for (let item of this.topicTSRs)
                data["topicTSRs"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedTags)) {
            data["assignedTags"] = [];
            for (let item of this.assignedTags)
                data["assignedTags"].push(item);
        }
        if (Array.isArray(this.groupedTags)) {
            data["groupedTags"] = [];
            for (let item of this.groupedTags)
                data["groupedTags"].push(item.toJSON());
        }
        data["topic"] = this.topic ? this.topic.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQItemEditOutputDto {
    qItem: QItemEditDto;
    topicTags: TopicTagListDto[] | undefined;
    topicTSRs: TopicTagListDto[] | undefined;
    assignedTags: number[] | undefined;
    groupedTags: GroupedTagsDto[] | undefined;
    topic: TopicDto;
}

export class QItemListDto implements IQItemListDto {
    id!: number;
    qText!: string | undefined;
    source!: string;
    creatorUser!: string;
    creationTime!: Date;
    tagIds!: number[] | undefined;
    isVerified!: boolean;
    isInProd!: boolean;

    constructor(data?: IQItemListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qText = _data["qText"];
            this.source = _data["source"];
            this.creatorUser = _data["creatorUser"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            this.isVerified = _data["isVerified"];
            this.isInProd = _data["isInProd"];
        }
    }

    static fromJS(data: any): QItemListDto {
        data = typeof data === 'object' ? data : {};
        let result = new QItemListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qText"] = this.qText;
        data["source"] = this.source;
        data["creatorUser"] = this.creatorUser;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["isVerified"] = this.isVerified;
        data["isInProd"] = this.isInProd;
        return data;
    }
}

export interface IQItemListDto {
    id: number;
    qText: string | undefined;
    source: string;
    creatorUser: string;
    creationTime: Date;
    tagIds: number[] | undefined;
    isVerified: boolean;
    isInProd: boolean;
}

export class QItemListDtoPagedResultDto implements IQItemListDtoPagedResultDto {
    items!: QItemListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IQItemListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QItemListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): QItemListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new QItemListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IQItemListDtoPagedResultDto {
    items: QItemListDto[] | undefined;
    totalCount: number;
}

export class QItemResultDto implements IQItemResultDto {
    items!: QItemListDto[] | undefined;
    totalCount!: number;
    tags!: TopicTagListDto[] | undefined;

    constructor(data?: IQItemResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QItemListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TopicTagListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QItemResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new QItemResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQItemResultDto {
    items: QItemListDto[] | undefined;
    totalCount: number;
    tags: TopicTagListDto[] | undefined;
}

export class QReportDataByTagDto implements IQReportDataByTagDto {
    tags!: string[] | undefined;
    responseTime!: number[] | undefined;
    strength!: number[] | undefined;
    strengthBM!: number[] | undefined;
    responseTimeBM!: number[] | undefined;
    focusTags!: string[] | undefined;
    focus!: number[] | undefined;

    constructor(data?: IQReportDataByTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["responseTime"])) {
                this.responseTime = [] as any;
                for (let item of _data["responseTime"])
                    this.responseTime!.push(item);
            }
            if (Array.isArray(_data["strength"])) {
                this.strength = [] as any;
                for (let item of _data["strength"])
                    this.strength!.push(item);
            }
            if (Array.isArray(_data["strengthBM"])) {
                this.strengthBM = [] as any;
                for (let item of _data["strengthBM"])
                    this.strengthBM!.push(item);
            }
            if (Array.isArray(_data["responseTimeBM"])) {
                this.responseTimeBM = [] as any;
                for (let item of _data["responseTimeBM"])
                    this.responseTimeBM!.push(item);
            }
            if (Array.isArray(_data["focusTags"])) {
                this.focusTags = [] as any;
                for (let item of _data["focusTags"])
                    this.focusTags!.push(item);
            }
            if (Array.isArray(_data["focus"])) {
                this.focus = [] as any;
                for (let item of _data["focus"])
                    this.focus!.push(item);
            }
        }
    }

    static fromJS(data: any): QReportDataByTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new QReportDataByTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.responseTime)) {
            data["responseTime"] = [];
            for (let item of this.responseTime)
                data["responseTime"].push(item);
        }
        if (Array.isArray(this.strength)) {
            data["strength"] = [];
            for (let item of this.strength)
                data["strength"].push(item);
        }
        if (Array.isArray(this.strengthBM)) {
            data["strengthBM"] = [];
            for (let item of this.strengthBM)
                data["strengthBM"].push(item);
        }
        if (Array.isArray(this.responseTimeBM)) {
            data["responseTimeBM"] = [];
            for (let item of this.responseTimeBM)
                data["responseTimeBM"].push(item);
        }
        if (Array.isArray(this.focusTags)) {
            data["focusTags"] = [];
            for (let item of this.focusTags)
                data["focusTags"].push(item);
        }
        if (Array.isArray(this.focus)) {
            data["focus"] = [];
            for (let item of this.focus)
                data["focus"].push(item);
        }
        return data;
    }
}

export interface IQReportDataByTagDto {
    tags: string[] | undefined;
    responseTime: number[] | undefined;
    strength: number[] | undefined;
    strengthBM: number[] | undefined;
    responseTimeBM: number[] | undefined;
    focusTags: string[] | undefined;
    focus: number[] | undefined;
}

export class RegisterInputModel implements IRegisterInputModel {
    name!: string;
    surname!: string;
    userName!: string;
    password!: string;

    constructor(data?: IRegisterInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): RegisterInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IRegisterInputModel {
    name: string;
    surname: string;
    userName: string;
    password: string;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword!: string;
    userId!: number;
    newPassword!: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class RoleDto implements IRoleDto {
    id!: number;
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items!: RoleDto[] | undefined;
    totalCount!: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number;
    name!: string;
    displayName!: string;
    description!: string | undefined;
    isStatic!: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        return data;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: Date;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: Date;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class StringListResultDto implements IStringListResultDto {
    items!: string[] | undefined;

    constructor(data?: IStringListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
        }
    }

    static fromJS(data: any): StringListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StringListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        return data;
    }
}

export interface IStringListResultDto {
    items: string[] | undefined;
}

export class StuCourseDetailDto implements IStuCourseDetailDto {
    id!: number;
    topic!: TopicDto;
    topicId!: number;
    title!: string | undefined;
    parentId!: number | undefined;
    topicOrder!: number;
    isAvailableByDate!: boolean;
    isAvailableOnPrevComp!: boolean;
    availableDate!: string | undefined;
    progress!: number;
    ability!: number;

    constructor(data?: IStuCourseDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.topic = _data["topic"] ? TopicDto.fromJS(_data["topic"]) : <any>undefined;
            this.topicId = _data["topicId"];
            this.title = _data["title"];
            this.parentId = _data["parentId"];
            this.topicOrder = _data["topicOrder"];
            this.isAvailableByDate = _data["isAvailableByDate"];
            this.isAvailableOnPrevComp = _data["isAvailableOnPrevComp"];
            this.availableDate = _data["availableDate"];
            this.progress = _data["progress"];
            this.ability = _data["ability"];
        }
    }

    static fromJS(data: any): StuCourseDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new StuCourseDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["topic"] = this.topic ? this.topic.toJSON() : <any>undefined;
        data["topicId"] = this.topicId;
        data["title"] = this.title;
        data["parentId"] = this.parentId;
        data["topicOrder"] = this.topicOrder;
        data["isAvailableByDate"] = this.isAvailableByDate;
        data["isAvailableOnPrevComp"] = this.isAvailableOnPrevComp;
        data["availableDate"] = this.availableDate;
        data["progress"] = this.progress;
        data["ability"] = this.ability;
        return data;
    }
}

export interface IStuCourseDetailDto {
    id: number;
    topic: TopicDto;
    topicId: number;
    title: string | undefined;
    parentId: number | undefined;
    topicOrder: number;
    isAvailableByDate: boolean;
    isAvailableOnPrevComp: boolean;
    availableDate: string | undefined;
    progress: number;
    ability: number;
}

export class StuCourseDto implements IStuCourseDto {
    id!: string;
    courseId!: string;
    name!: string | undefined;
    description!: string | undefined;
    icon!: string | undefined;
    rating!: string | undefined;
    topicId!: number;
    isTrial!: boolean;
    courseDetails!: StuCourseDetailDto[] | undefined;

    constructor(data?: IStuCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseId = _data["courseId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.rating = _data["rating"];
            this.topicId = _data["topicId"];
            this.isTrial = _data["isTrial"];
            if (Array.isArray(_data["courseDetails"])) {
                this.courseDetails = [] as any;
                for (let item of _data["courseDetails"])
                    this.courseDetails!.push(StuCourseDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StuCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new StuCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseId"] = this.courseId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["rating"] = this.rating;
        data["topicId"] = this.topicId;
        data["isTrial"] = this.isTrial;
        if (Array.isArray(this.courseDetails)) {
            data["courseDetails"] = [];
            for (let item of this.courseDetails)
                data["courseDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStuCourseDto {
    id: string;
    courseId: string;
    name: string | undefined;
    description: string | undefined;
    icon: string | undefined;
    rating: string | undefined;
    topicId: number;
    isTrial: boolean;
    courseDetails: StuCourseDetailDto[] | undefined;
}

export class StuCourseTopicDetailDto implements IStuCourseTopicDetailDto {
    id!: number;
    subTopic!: StuCourseDetailDto;
    topicResourses!: TopicResourceDto[] | undefined;

    constructor(data?: IStuCourseTopicDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subTopic = _data["subTopic"] ? StuCourseDetailDto.fromJS(_data["subTopic"]) : <any>undefined;
            if (Array.isArray(_data["topicResourses"])) {
                this.topicResourses = [] as any;
                for (let item of _data["topicResourses"])
                    this.topicResourses!.push(TopicResourceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StuCourseTopicDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new StuCourseTopicDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subTopic"] = this.subTopic ? this.subTopic.toJSON() : <any>undefined;
        if (Array.isArray(this.topicResourses)) {
            data["topicResourses"] = [];
            for (let item of this.topicResourses)
                data["topicResourses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStuCourseTopicDetailDto {
    id: number;
    subTopic: StuCourseDetailDto;
    topicResourses: TopicResourceDto[] | undefined;
}

export class StuCourseTopicDto implements IStuCourseTopicDto {
    id!: number;
    course!: StuCourseDto;
    topic!: StuCourseDetailDto;
    courseTopicDetails!: StuCourseTopicDetailDto[] | undefined;

    constructor(data?: IStuCourseTopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.course = _data["course"] ? StuCourseDto.fromJS(_data["course"]) : <any>undefined;
            this.topic = _data["topic"] ? StuCourseDetailDto.fromJS(_data["topic"]) : <any>undefined;
            if (Array.isArray(_data["courseTopicDetails"])) {
                this.courseTopicDetails = [] as any;
                for (let item of _data["courseTopicDetails"])
                    this.courseTopicDetails!.push(StuCourseTopicDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StuCourseTopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new StuCourseTopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["course"] = this.course ? this.course.toJSON() : <any>undefined;
        data["topic"] = this.topic ? this.topic.toJSON() : <any>undefined;
        if (Array.isArray(this.courseTopicDetails)) {
            data["courseTopicDetails"] = [];
            for (let item of this.courseTopicDetails)
                data["courseTopicDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStuCourseTopicDto {
    id: number;
    course: StuCourseDto;
    topic: StuCourseDetailDto;
    courseTopicDetails: StuCourseTopicDetailDto[] | undefined;
}

export class StudentHeatMapDto implements IStudentHeatMapDto {
    userId!: number;
    userFullName!: string | undefined;
    tagId!: number;
    topicTag!: string | undefined;
    isCompleted!: boolean | undefined;
    strength!: number;

    constructor(data?: IStudentHeatMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userFullName = _data["userFullName"];
            this.tagId = _data["tagId"];
            this.topicTag = _data["topicTag"];
            this.isCompleted = _data["isCompleted"];
            this.strength = _data["strength"];
        }
    }

    static fromJS(data: any): StudentHeatMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentHeatMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userFullName"] = this.userFullName;
        data["tagId"] = this.tagId;
        data["topicTag"] = this.topicTag;
        data["isCompleted"] = this.isCompleted;
        data["strength"] = this.strength;
        return data;
    }
}

export interface IStudentHeatMapDto {
    userId: number;
    userFullName: string | undefined;
    tagId: number;
    topicTag: string | undefined;
    isCompleted: boolean | undefined;
    strength: number;
}

export class StudentReportOutputDto implements IStudentReportOutputDto {
    name!: string | undefined;
    userId!: number;
    isCompleted!: boolean | undefined;

    constructor(data?: IStudentReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userId = _data["userId"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): StudentReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userId"] = this.userId;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IStudentReportOutputDto {
    name: string | undefined;
    userId: number;
    isCompleted: boolean | undefined;
}

export class StudentReportOutputDtoListResultDto implements IStudentReportOutputDtoListResultDto {
    items!: StudentReportOutputDto[] | undefined;

    constructor(data?: IStudentReportOutputDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StudentReportOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudentReportOutputDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentReportOutputDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudentReportOutputDtoListResultDto {
    items: StudentReportOutputDto[] | undefined;
}

export class StudentReportPrByCTDto implements IStudentReportPrByCTDto {
    userId!: number;
    userFullName!: string | undefined;
    percentage!: number;
    classId!: number;

    constructor(data?: IStudentReportPrByCTDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userFullName = _data["userFullName"];
            this.percentage = _data["percentage"];
            this.classId = _data["classId"];
        }
    }

    static fromJS(data: any): StudentReportPrByCTDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentReportPrByCTDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userFullName"] = this.userFullName;
        data["percentage"] = this.percentage;
        data["classId"] = this.classId;
        return data;
    }
}

export interface IStudentReportPrByCTDto {
    userId: number;
    userFullName: string | undefined;
    percentage: number;
    classId: number;
}

export class TSRListDto implements ITSRListDto {
    id!: number;
    name!: string;
    topicId!: number;
    topicTitle!: string | undefined;
    creationTime!: Date;
    creatorUserName!: string | undefined;

    constructor(data?: ITSRListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.topicId = _data["topicId"];
            this.topicTitle = _data["topicTitle"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserName = _data["creatorUserName"];
        }
    }

    static fromJS(data: any): TSRListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TSRListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["topicId"] = this.topicId;
        data["topicTitle"] = this.topicTitle;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserName"] = this.creatorUserName;
        return data;
    }
}

export interface ITSRListDto {
    id: number;
    name: string;
    topicId: number;
    topicTitle: string | undefined;
    creationTime: Date;
    creatorUserName: string | undefined;
}

export class TSRListDtoListResultDto implements ITSRListDtoListResultDto {
    items!: TSRListDto[] | undefined;

    constructor(data?: ITSRListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TSRListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TSRListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TSRListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITSRListDtoListResultDto {
    items: TSRListDto[] | undefined;
}

export class TenantDto implements ITenantDto {
    id!: number;
    tenancyName!: string;
    name!: string;
    isActive!: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items!: TenantDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class TopicDto implements ITopicDto {
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    parentId!: number | undefined;

    constructor(data?: ITopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): TopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface ITopicDto {
    id: number;
    title: string | undefined;
    description: string | undefined;
    parentId: number | undefined;
}

export class TopicDtoListResultDto implements ITopicDtoListResultDto {
    items!: TopicDto[] | undefined;

    constructor(data?: ITopicDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TopicDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TopicDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopicDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITopicDtoListResultDto {
    items: TopicDto[] | undefined;
}

export class TopicMapItem implements ITopicMapItem {
    topic!: TopicDto;
    topicResources!: FMapItemDto[] | undefined;

    constructor(data?: ITopicMapItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topic = _data["topic"] ? TopicDto.fromJS(_data["topic"]) : <any>undefined;
            if (Array.isArray(_data["topicResources"])) {
                this.topicResources = [] as any;
                for (let item of _data["topicResources"])
                    this.topicResources!.push(FMapItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TopicMapItem {
        data = typeof data === 'object' ? data : {};
        let result = new TopicMapItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topic"] = this.topic ? this.topic.toJSON() : <any>undefined;
        if (Array.isArray(this.topicResources)) {
            data["topicResources"] = [];
            for (let item of this.topicResources)
                data["topicResources"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITopicMapItem {
    topic: TopicDto;
    topicResources: FMapItemDto[] | undefined;
}

export class TopicResourceDto implements ITopicResourceDto {
    id!: number;
    topicId!: number;
    resourceType!: string;
    title!: string | undefined;
    resource!: string | undefined;
    resourceLink!: string | undefined;
    imageLink!: string | undefined;
    isPublic!: boolean;
    creatorUser!: string | undefined;

    constructor(data?: ITopicResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.topicId = _data["topicId"];
            this.resourceType = _data["resourceType"];
            this.title = _data["title"];
            this.resource = _data["resource"];
            this.resourceLink = _data["resourceLink"];
            this.imageLink = _data["imageLink"];
            this.isPublic = _data["isPublic"];
            this.creatorUser = _data["creatorUser"];
        }
    }

    static fromJS(data: any): TopicResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopicResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["topicId"] = this.topicId;
        data["resourceType"] = this.resourceType;
        data["title"] = this.title;
        data["resource"] = this.resource;
        data["resourceLink"] = this.resourceLink;
        data["imageLink"] = this.imageLink;
        data["isPublic"] = this.isPublic;
        data["creatorUser"] = this.creatorUser;
        return data;
    }
}

export interface ITopicResourceDto {
    id: number;
    topicId: number;
    resourceType: string;
    title: string | undefined;
    resource: string | undefined;
    resourceLink: string | undefined;
    imageLink: string | undefined;
    isPublic: boolean;
    creatorUser: string | undefined;
}

export class TopicTagListDto implements ITopicTagListDto {
    id!: number;
    name!: string;
    description!: string;
    qCount!: number;

    constructor(data?: ITopicTagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.qCount = _data["qCount"];
        }
    }

    static fromJS(data: any): TopicTagListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopicTagListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["qCount"] = this.qCount;
        return data;
    }
}

export interface ITopicTagListDto {
    id: number;
    name: string;
    description: string;
    qCount: number;
}

export class TopicTagListDtoPagedResultDto implements ITopicTagListDtoPagedResultDto {
    items!: TopicTagListDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITopicTagListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TopicTagListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TopicTagListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopicTagListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ITopicTagListDtoPagedResultDto {
    items: TopicTagListDto[] | undefined;
    totalCount: number;
}

export class UpdateArticleInputDto implements IUpdateArticleInputDto {
    id!: number;
    title!: string;
    content!: string;
    tagIds!: number[] | undefined;

    constructor(data?: IUpdateArticleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.content = _data["content"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateArticleInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["content"] = this.content;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateArticleInputDto {
    id: number;
    title: string;
    content: string;
    tagIds: number[] | undefined;
}

export class UpdateMyGoalsInputDto implements IUpdateMyGoalsInputDto {
    examType!: string | undefined;
    desiredRank!: number;
    physics!: GoalSubjectDto;
    chemistry!: GoalSubjectDto;
    maths!: GoalSubjectDto;
    schoolName!: string | undefined;
    syllabus!: string | undefined;

    constructor(data?: IUpdateMyGoalsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examType = _data["examType"];
            this.desiredRank = _data["desiredRank"];
            this.physics = _data["physics"] ? GoalSubjectDto.fromJS(_data["physics"]) : <any>undefined;
            this.chemistry = _data["chemistry"] ? GoalSubjectDto.fromJS(_data["chemistry"]) : <any>undefined;
            this.maths = _data["maths"] ? GoalSubjectDto.fromJS(_data["maths"]) : <any>undefined;
            this.schoolName = _data["schoolName"];
            this.syllabus = _data["syllabus"];
        }
    }

    static fromJS(data: any): UpdateMyGoalsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMyGoalsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examType"] = this.examType;
        data["desiredRank"] = this.desiredRank;
        data["physics"] = this.physics ? this.physics.toJSON() : <any>undefined;
        data["chemistry"] = this.chemistry ? this.chemistry.toJSON() : <any>undefined;
        data["maths"] = this.maths ? this.maths.toJSON() : <any>undefined;
        data["schoolName"] = this.schoolName;
        data["syllabus"] = this.syllabus;
        return data;
    }
}

export interface IUpdateMyGoalsInputDto {
    examType: string | undefined;
    desiredRank: number;
    physics: GoalSubjectDto;
    chemistry: GoalSubjectDto;
    maths: GoalSubjectDto;
    schoolName: string | undefined;
    syllabus: string | undefined;
}

export class UpdateQActionInputDto implements IUpdateQActionInputDto {
    id!: number;
    isEnabled!: boolean;

    constructor(data?: IUpdateQActionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UpdateQActionInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQActionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IUpdateQActionInputDto {
    id: number;
    isEnabled: boolean;
}

export class UpdateQItemInputDto implements IUpdateQItemInputDto {
    id!: number;
    topicId!: number;
    qText!: string;
    option1!: string;
    option2!: string;
    option3!: string;
    option4!: string;
    answer!: number;
    difficulty!: number;
    discrimination!: number;
    guessing!: number;
    source!: string | undefined;
    hint!: string | undefined;
    solution!: string | undefined;
    tagIds!: number[] | undefined;
    tsrId!: number;
    isVerified!: boolean;
    isInProd!: boolean;

    constructor(data?: IUpdateQItemInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.topicId = _data["topicId"];
            this.qText = _data["qText"];
            this.option1 = _data["option1"];
            this.option2 = _data["option2"];
            this.option3 = _data["option3"];
            this.option4 = _data["option4"];
            this.answer = _data["answer"];
            this.difficulty = _data["difficulty"];
            this.discrimination = _data["discrimination"];
            this.guessing = _data["guessing"];
            this.source = _data["source"];
            this.hint = _data["hint"];
            this.solution = _data["solution"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            this.tsrId = _data["tsrId"];
            this.isVerified = _data["isVerified"];
            this.isInProd = _data["isInProd"];
        }
    }

    static fromJS(data: any): UpdateQItemInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQItemInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["topicId"] = this.topicId;
        data["qText"] = this.qText;
        data["option1"] = this.option1;
        data["option2"] = this.option2;
        data["option3"] = this.option3;
        data["option4"] = this.option4;
        data["answer"] = this.answer;
        data["difficulty"] = this.difficulty;
        data["discrimination"] = this.discrimination;
        data["guessing"] = this.guessing;
        data["source"] = this.source;
        data["hint"] = this.hint;
        data["solution"] = this.solution;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["tsrId"] = this.tsrId;
        data["isVerified"] = this.isVerified;
        data["isInProd"] = this.isInProd;
        return data;
    }
}

export interface IUpdateQItemInputDto {
    id: number;
    topicId: number;
    qText: string;
    option1: string;
    option2: string;
    option3: string;
    option4: string;
    answer: number;
    difficulty: number;
    discrimination: number;
    guessing: number;
    source: string | undefined;
    hint: string | undefined;
    solution: string | undefined;
    tagIds: number[] | undefined;
    tsrId: number;
    isVerified: boolean;
    isInProd: boolean;
}

export class UpdateQItemVerificationInputDto implements IUpdateQItemVerificationInputDto {
    id!: number;
    isVerified!: boolean;
    isInProd!: boolean;

    constructor(data?: IUpdateQItemVerificationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isVerified = _data["isVerified"];
            this.isInProd = _data["isInProd"];
        }
    }

    static fromJS(data: any): UpdateQItemVerificationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQItemVerificationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isVerified"] = this.isVerified;
        data["isInProd"] = this.isInProd;
        return data;
    }
}

export interface IUpdateQItemVerificationInputDto {
    id: number;
    isVerified: boolean;
    isInProd: boolean;
}

export class UpdateTopicInputDto implements IUpdateTopicInputDto {
    id!: number;
    title!: string;
    description!: string | undefined;

    constructor(data?: IUpdateTopicInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateTopicInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTopicInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateTopicInputDto {
    id: number;
    title: string;
    description: string | undefined;
}

export class UpdateUserDto implements IUpdateUserDto {
    id!: number;
    name!: string;
    surname!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    roleName!: string;

    constructor(data?: IUpdateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UpdateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUpdateUserDto {
    id: number;
    name: string;
    surname: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    roleName: string;
}

export class UploadImageOutputDto implements IUploadImageOutputDto {
    attachment!: string | undefined;

    constructor(data?: IUploadImageOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachment = _data["attachment"];
        }
    }

    static fromJS(data: any): UploadImageOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadImageOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachment"] = this.attachment;
        return data;
    }
}

export interface IUploadImageOutputDto {
    attachment: string | undefined;
}

export class UserDto implements IUserDto {
    id!: number;
    userName!: string;
    name!: string;
    surname!: string;
    emailAddress!: string;
    isActive!: boolean;
    fullName!: string | undefined;
    lastLoginTime!: Date | undefined;
    creationTime!: Date;
    roleName!: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? new Date(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: Date | undefined;
    creationTime: Date;
    roleName: string | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items!: UserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserEditDto implements IUserEditDto {
    id!: number;
    name!: string;
    surname!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    roleName!: string | undefined;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserEditDto {
    id: number;
    name: string;
    surname: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    roleName: string | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
}

export class UserRoleDto implements IUserRoleDto {
    name!: string;
    normalizedName!: string;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        return data;
    }
}

export interface IUserRoleDto {
    name: string;
    normalizedName: string;
}

export class VerifyInputModel implements IVerifyInputModel {
    userName!: string;
    code!: string | undefined;

    constructor(data?: IVerifyInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): VerifyInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["code"] = this.code;
        return data;
    }
}

export interface IVerifyInputModel {
    userName: string;
    code: string | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

/**
 * Configuration class needed in base class.
 * The config is provided to the API client at initialization time.
 * API clients inherit from #AuthorizedApiBase and provide the config.
 */

export class IConfig {
  /**
   * Returns a valid value for the Authorization header.
   * Used to dynamically inject the current auth header.
   */
  getAuthorization = () => 'the-authentication-token';
}